import { Component, Input, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { CommonProjectDataService } from "../../_services/common-project-data.service";

import { FlashMessagesService } from "angular2-flash-messages";
import { Router, ActivatedRoute } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
}
  from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { InvoiceItemComponent } from '../invoice-item/invoice-item.component';
import { CheckOutComponent } from '../check-out/check-out.component';
import { ShippingInfoComponent } from '../shipping-info/shipping-info.component';
import { UpdateInvoiceAddressComponent } from '../update-invoice-address/update-invoice-address.component';
import { projection } from '@angular/core/src/render3/instructions';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProductDetailComponent } from '../product-detail/product-detail.component';
import { SaveQuoteComponent } from '../save-quote/save-quote.component';
import { parse } from 'url';
import { GuestEmailComponent } from '../guest-email/guest-email.component';
import { MailPublicUrlComponent } from '../mail-public-url/mail-public-url.component';
import { environment } from '../../../environments/environment';
import { CodegenComponentFactoryResolver } from '@angular/core/src/linker/component_factory_resolver';
import { PaymentRefundComponent } from '../payment-refund/payment-refund.component';
import { AssignStaffComponent } from '../assign-staff/assign-staff.component';
import { AddTaskComponent } from '../add-task/add-task.component';
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import { StoreProductPriceComponent } from '../../mnt-stores/store-product-price/store-product-price.component';
import { SquareupResponseComponent } from '../squareup-response/squareup-response.component'
import { forEach } from '@angular/router/src/utils/collection';
import { AddProductStepComponent } from '../add-product-step/add-product-step.component';
import { SettingService } from '../../_services/setting.service';
import { AssignToStoreComponent } from '../assign-to-store/assign-to-store.component';
import { SmsPublicUrlComponent } from '../sms-public-url/sms-public-url.component';
@Component({
  selector: 'app-invoices-form',
  templateUrl: './invoices-form.component.html',
  styleUrls: ['./invoices-form.component.css']

})
export class InvoicesFormComponent implements OnInit {
  @Input() id: any;
  @Input() orderStatus: any;
  @Input() type: any;
  @Output() toggleForm = new EventEmitter<boolean>();
  @ViewChild(AddProductStepComponent) addProductStepComponent: AddProductStepComponent;
  form: FormGroup;
  public customeLineItemError = "";
  public isPayLater = false;
  public isShowAddress = false;
  public loading = false;
  public isReplyButton = true;
  public isCommentBox = false;
  public projects: any = {};
  public userDetails: any = {};
  public balanceAmount: number;
  public comment: string;
  public message: string;
  public selectedFile = null;
  public mockup_upload_error = null;
  public assignStatus: string = "";
  public customLineItems: Array<any> = [];
  public isOpenComments = {};
  public currentMessage = {};
  public replydisabled = true;
  private tempProjectData: any;
  public customItemError = false;
  public quantityError = false;
  public lineItemError = false;
  public lineItemdisabled = true;
  public page = 1;
  public limit = 12;
  public sortColumnName = "item";
  public sortDirection = "asc";
  public searchText: string;
  quoteGuestMail: string = "";
  paidInvoice: string = "";
  duplicateQuoteId = '';
  orderId = '';
  public isSectionEdit = false;
  public inkTypeLists: Array<any> = [];
  public finishingCount = 0;
  private errorMsg = null;
  public isinkdetail = 0;
  public isShowUrl = false;
  private isShowCheckout = false;
  private publicToken: string;
  private quotesaved = ""
  public oneTimeDiscount = 0;
  public isPackingSlip = false;
  public errorClass = false;
  public taskList: Array<any> = [];
  private isPayment = 'No';
  public receivableCount: number;
  public isturnOffSSInventory = false;
  public productMatrix: any = [];
  public finishingChecked = true;
  public checkedProjectTabLocs: Array<any> = [];
  public checkedProjectTabFinishing: Array<any> = [];
  public isAnyOptionOfTabCheckbox = false;
  public jobStatusLists = [
    { sKey: '', sValue: 'Change Status' },
    { sKey: "Assign", sValue: "Assign" },
    { sKey: "Generate Mockups", sValue: "Generate Mockups" },
    { sKey: "Mockups Submitted", sValue: "Mockups Submitted" },
    { sKey: "Order Queue", sValue: "Order Queue" },
    { sKey: "Garments Ordered", sValue: "Garments Ordered" },
    { sKey: "Print Production", sValue: "Print Production" },
  ];
  public oneTimeDiscountTypes = [
    { sKey: '', sValue: 'Select' },
    { sKey: "Doller Amount", sValue: "Dollar Amount" },
    { sKey: "Percentage", sValue: "Percentage" }
  ];
  private defaultLineItems = [
    {
      item: "checking",
      price: "0",
      quantity: "0",
      description: ""
    }
  ];

  private defaultProjectData = {
    'projects_data': [
      {
        'section_items': [
          {
            'lable': "Section Title Click to Edit",
            'custom_items': [
              {
                item: "",
                price: "0",
                quantity: "0",
                description: ""
              }
            ]
          }
        ],
        'message_count': 0,
        'totalProjectQuantity': 0,
        'total_printing_price': 0
      }
    ],
    'user_id': '',
    'shipping_address': { 'address_id': '' },
    'turn_around_time_key': 0,
    'shipping_method_key': '',
    'total_quantity': 0
  };
  options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Array<any> = [];
  public turnAroundName: string;
  public shippingMethodName: string;
  public isQuoteRequest = false;
  public totalProjectQuantity: any = [];
  public grandTotalPrice = 0;
  public orderType = 'Quote';
  public customOrderId = '';
  public isValidData = false;
  public total_item_qty = 0;
  public total_item_price = 0;
  public isLessOrderLimit = 0;
  public isQuantityValidated = false;
  public min_order_qty = 0;
  public is_payment_term = 'No';
  turnAroundTimes: Array<any> = [];
  shipping: Array<any> = [];
  address: Array<any> = [];
  public activeProjectIndex = 0;
  public selectedProductColors = {};
  public selectedColors: any = [];
  public viewClientId: string;
  public publicUrl: string;
  public prevPrice = 0;
  public isturnOffPerPriceView = false;
  public isTurnOffImpressionCost = false;
  public quoteData: any = {};
  public storeId: string;
  public isPublicQuoteCreation = false;
  public isClickPickerStatus = false;
  public isTriggeredinvoiceCheckbox = false;
  public isPriceOverrideInvoice = false;
  public isRebindPriceOverview = false;
  headerShow: boolean = false;
  public isCustomer = false;
  public isShippingOption = true;
  public isLocalPickupOption = true;
  public shopId: string = '';
  public previousStatus: string = '';
  public tooltipOptions: any = [];
  public isNoNewQuote = false;
  public hideAllEditIcon = false;
  public priceOverrideLoading = false;
  public priceOverrideLocation: any = {};
  public triggerEmail: boolean = false;
  public isConnectQBO:boolean = false;
  public cardProcessingFees: any = [];
  dueDateForm = new FormGroup({ dueDate: new FormControl({ value: null, disabled: true }) });
  public scheduledDate: string = '';
  public paymentHistory: any = [];
  public refundHistory: any = [];

  constructor
    (
      private fb: FormBuilder,
      private CommonService: CommonService,
      private _flashMessagesService: FlashMessagesService,
      private router: Router,
      private activateroute: ActivatedRoute,
      private dialog: MatDialog,
      private CommonProjectDataService: CommonProjectDataService,
      private SettingService: SettingService
    ) {

    this.form = fb.group({
      customLineItems: fb.array([])
    });
    var routerVerifier = this.router.url.split("/");
    routerVerifier.includes("builder") ? localStorage.setItem("isPublicQuoteCreation", "Yes") : localStorage.setItem("isPublicQuoteCreation", "No");
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
    this.isConnectQBO = this.CommonService.getIsConnectQBO();
  }

  ngOnInit() {
    this.isNoNewQuote = localStorage.getItem('create_new_quote') ? false : true;
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    this.shopId = this.userDetails.type === 'Shop' ? localStorage.getItem("userID") : this.userDetails.shop_id;
    this.isCustomer = this.userDetails.type == 'Printer' || this.userDetails.type == 'Designer' ? true : this.isPublicQuoteCreation;

    this.CommonProjectDataService.receivableCount.subscribe(recCount => {
      this.receivableCount = recCount
    })
    this.isShippingOptions();
    this.getInkType();
    this.getFinishingData();
    this.activeProjectIndex = this.CommonProjectDataService.getActiveProjectIndex() ? parseInt(this.CommonProjectDataService.getActiveProjectIndex()) : 0;
    this.CommonProjectDataService.storeActiveProjectIndex(this.activeProjectIndex);
    this.CommonProjectDataService.storeOrderType(this.orderType);
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    this.customLineItems = JSON.parse(JSON.stringify(this.defaultLineItems));
    this.isQuoteRequest = this.CommonProjectDataService.getQuoteRequest();
    this.publicToken = this.CommonProjectDataService.getPublicUrlToken();
    this.isturnOffPerPriceView = this.CommonProjectDataService.getTurnOffPriceView();
    this.isTurnOffImpressionCost = this.CommonProjectDataService.getTurnOffImpressionCost();

    if (this.id != "order") {
      this.CommonProjectDataService.storeClientId(null);
      if (this.type == 'Duplicate') {
        this.resetSharingData();
      }
      this.getTaskDetail();
      this.getOrderList();
      this.activeProjectIndex = 0;
      this.CommonProjectDataService.storeActiveProjectIndex(this.activeProjectIndex);
    }
    else {
      this.id = this.projects.order_id ? this.projects.order_id : localStorage.getItem('resumeOrder') ? localStorage.getItem('resumeOrder') : this.id;
      this.viewClientId = this.CommonProjectDataService.getClientId() ? this.CommonProjectDataService.getClientId() : null;
      if (this.isQuoteRequest) {
        this.activeProjectIndex = 0;
        this.CommonProjectDataService.storeActiveProjectIndex(this.activeProjectIndex);
        this.projects = JSON.parse(JSON.stringify(this.defaultProjectData));
        this.resetSharingData();
      }
      else {
        this.totalProjectQuantity = JSON.parse(JSON.stringify(this.CommonProjectDataService.getTotalProjectQuantity()));
        this.grandTotalPrice = JSON.parse(JSON.stringify(this.CommonProjectDataService.getTotalPrice()));
        this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
        this.tempProjectData = this.projects.hasOwnProperty('projects_data') ? JSON.parse(JSON.stringify(this.projects.projects_data)) : {};
        this.orderType = this.projects.type ? this.projects.type : 'Quote';
        this.CommonProjectDataService.storeOrderType(this.orderType);
        if (this.projects.paid_amount) {
          this.balanceAmount = (this.projects.grand_total_price - this.projects.paid_amount);
        }
        else {
          this.balanceAmount = (this.projects.grand_total_price);
        }
        if (this.projects.refunded_amount) {
          this.balanceAmount += Number(this.projects.refunded_amount);
        }
        this.showConfirmMessage();
      }

      if (this.projects.turn_around_times) {
        this.turnAroundName = this.projects.turn_around_times;
      }

    }
    this.getCustomeLineItems();

    if (this.projects.order_id) {
      this.isShowUrl = true;
    }
    if (this.projects.store_id) {
      this.storeId = this.projects.store_id;
    }
    this.isturnOffSSInventory = this.CommonProjectDataService.getTurnOffSSInventory();
    this.CommonProjectDataService.storeCurrentIndexForStep(6);
    this.getProductMatrix('all');
    this.productMatrix = this.CommonProjectDataService.getProductMatrix();
    this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
    if (this.projects.hasOwnProperty('getPrice') && this.projects.getPrice === true) {
      this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
      this.projects.getPrice = false;
      this.CommonProjectDataService.store(this.projects);
      this.getPrice();
    }
    if (this.projects.delivery_date) {
      this.dueDateForm.controls.dueDate.setValue(new Date(this.projects.delivery_date));
    }
    if (this.projects.projectIndexForCheckboxTabs) {
      this.projects.projectIndexForCheckboxTabs.forEach((value) => {
        this.updateIsCheckedProjectTab(value);
      });
    }
    this.previousStatus = this.projects.status ? this.projects.status : this.previousStatus;

    this.getTooltipOptions();
    this.scheduledDate = this.CommonProjectDataService.getScheduledDate();
  }

  //filter
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }
  debugData(data: any) {
    console.log(data);
  }
  checkValidStatus = function (cStatus) {
    let validStatus = this.jobStatusLists.find(x => x.sKey === cStatus);
    return (!validStatus) ? true : false;
  }

  resetSharingData() {
    this.CommonProjectDataService.storeDeliveryDate('');
    this.CommonProjectDataService.storeOrderId('');
    this.CommonProjectDataService.storeClientName('');
    this.CommonProjectDataService.store(this.projects);
    this.CommonProjectDataService.storeProductColor({});
    this.CommonProjectDataService.storeSelectedColor([]);
    this.CommonProjectDataService.storeOwnGarmentsWeight({});
    this.CommonProjectDataService.storeTotalProjectQuantity([]);
    this.CommonProjectDataService.storeTotalPrice(0);
    this.CommonProjectDataService.storeSelectedProductPrice({});
    this.CommonProjectDataService.storeQuantityValidated(false);
    this.CommonProjectDataService.storeQuoteRequest(false);
    this.CommonProjectDataService.storeOrderType(this.orderType);
    this.CommonProjectDataService.storeCompanyName('');
    this.CommonProjectDataService.storeTurnOffPriceView(false);
    this.CommonProjectDataService.storeScheduledDate('');
  }

  onLogoChanged = function (event, invoiceId, projectKey, location) {
    this.mockup_upload_error = null;
    this.selectedFile = event.target.files[0];

    let imgTypeArr = [];
    let validFileTypeArr = [];
    let mockupupload;
    let apiName;

    if (event.target.name == 'upload_mockup') {
      mockupupload = "mockup";
      apiName = "upload/mockup";
      imgTypeArr = [
        "image/jpeg",
        "image/jpg",
        "image/bmp",
        "image/png"
      ];
      if (this.selectedFile.size > 12582912) {
        this.mockup_upload_error =
          "File too large. File must be less than 12 megabytes.";
      }
      if (imgTypeArr.indexOf(this.selectedFile.type) < 0) {
        this.mockup_upload_error =
          "Invalid Mockup file type. Only JPG and PNG types are accepted.";
      }
    }
    if (event.target.name == 'upload_mockup_spec') {
      mockupupload = "vector";
      apiName = "upload/vector";
      validFileTypeArr = [
        "image/jpeg",
        "image/jpg",
        "image/bmp",
        "image/png",
        "application/illustrator",
        "image/x-eps",
        "application/postscript",
        "image/vnd.adobe.photoshop",
        "image/svg+xml",
        "application/pdf"
      ];
      if (validFileTypeArr.indexOf(this.selectedFile.type) < 0) {
        this.mockup_upload_error =
          "Invalid Spec file type. Only JPG,BMP, PNG, AI, EPS, PDF, PSD and SVG types are accepted.";
      }
    }

    if (!this.mockup_upload_error) {
      this.loading = true;
      const uploadMockup = new FormData();
      uploadMockup.append(mockupupload, this.selectedFile, this.selectedFile.name);
      uploadMockup.append('id', localStorage.getItem("userID"));
      uploadMockup.append('invoice_id', invoiceId);
      uploadMockup.append('location', location);
      uploadMockup.append('project', projectKey);

      this.CommonService.apiService(
        "POST",
        apiName,
        uploadMockup
      ).subscribe((response: any) => {
        this.loading = false;

        if (response.status === true) {
          this.router.navigateByUrl('/RefrshComponent', { skipLocationChange: true }).then(() =>
            this.router.navigate(["/invoices/" + this.id]));
          this._flashMessagesService.show(response.message, { cssClass: 'alert-success', timeout: 5000 });
        }
        window.scrollTo(0, 0);
      },
        (err) => {
          this.loading = false;
          this._flashMessagesService.show(err.error.message, { cssClass: 'alert-warning', timeout: 5000 });
        })
    }
  }

  getOrderList = function () {
    this.loading = true;
    this.invoiceOptions = {
      id: localStorage.getItem("userID"),
      order_id: this.id == 'order' ? this.projects.order_id : this.id
    };
    let apiMethod: string;
    if (this.type == "Duplicate" && (this.duplicateQuoteId == '' || this.duplicateQuoteId == null)) {
      apiMethod = "order/duplicate";
    }
    else {
      apiMethod = "order"
    }
    this.CommonService.apiService(
      "POST",
      apiMethod,
      this.invoiceOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            if (response.data.type === 'Invoice') {
              localStorage.removeItem('backgroundOrderId');
              this.getPaymentHistory(response.data.type, response.data.order_id);
            }
            
            localStorage.setItem("quote_user_id", response.data.user_id);
            this.showSquareupResponseDialog(response.data);
            if (this.isPublicQuoteCreation == true) {
              let clientUserDetails = localStorage.getItem('clientUserDetails') ? JSON.parse(localStorage.getItem('clientUserDetails')) : {};
              if (clientUserDetails && clientUserDetails.username != response.data.user_username) {
                this.router.navigate(['/builder']);
              }
            }
            if (response.data.transactions && response.data.transactions[0] && response.data.transactions[0].transaction_id && response.data.transactions[0].transaction_id.includes('PayLater_')) {
              this.isPayLater = true;
            }
            let obj = JSON.parse(JSON.stringify(response));
            this.tempProjectData = JSON.parse(JSON.stringify(obj.data.projects_data));
            this.projects = obj.data;
            if (this.projects.store_id) {
              this.storeId = this.projects.store_id;
            }
            this.previousStatus = this.projects.status;

            this.isturnOffPerPriceView = this.projects.turn_off_price_per_peice && this.projects.turn_off_price_per_peice == '1' ? true : false;
            this.CommonProjectDataService.storeTurnOffPriceView(this.isturnOffPerPriceView);

            this.isTurnOffImpressionCost = this.projects.turn_off_impression_cost && this.projects.turn_off_impression_cost == '1' ? true : false;
            this.CommonProjectDataService.storeTurnOffImpressionCost(this.isTurnOffImpressionCost);

            this.isturnOffSSInventory = this.projects.turn_off_ss_inventory && this.projects.turn_off_ss_inventory == '1' ? true : false;
            this.CommonProjectDataService.storeTurnOffSSInventory(this.isturnOffSSInventory);

            this.orderType = obj.data.type;
            if (this.projects.projects_data[this.activeProjectIndex].selectedProductColors) {
              this.CommonProjectDataService.storeProductColor(this.projects.projects_data[this.activeProjectIndex].selectedProductColors);
            }
            this.CommonProjectDataService.storeIsInvoiceEditable(this.projects.isInvoiceEditable);
            this.CommonProjectDataService.storeOrderType(this.orderType);
            let st = obj.data.grand_total_price;

            this.publicToken = obj.data.public_url_token;
            this.CommonProjectDataService.storePublicUrlToken(this.publicToken);
            if (this.type == "Duplicate") {
              this.projects.order_id = this.duplicateQuoteId;
            }
            else {
              localStorage.setItem("resumeOrder", this.projects.order_id);
              localStorage.setItem("resumeOrderType", this.orderType);
            }

            if (this.projects.turn_around_times) {
              this.turnAroundName = this.projects.turn_around_times;
            }
            if (this.orderType == "Quote") {
              this.is_payment_term = obj.data.is_payment_term;
              this.getPrice();
              this.scheduledDate = response.data.scheduled_date ? response.data.scheduled_date : '';
              this.CommonProjectDataService.storeScheduledDate(this.scheduledDate);
            }
            else {
              if (this.type != "Duplicate") {
                localStorage.setItem("totalPrice", this.projects.grand_total_price);
                let username = this.projects.user_first_name ? this.projects.user_first_name : 'Guest';
                localStorage.setItem('userName', username);
                localStorage.setItem('clientId', this.projects.user_id);
              }
              // When OrderStatus is equal to Invoice assign perProjectTotalCost to the project tab.
              if (this.orderType == 'Invoice') {
                let whenPriceFound = true;
                this.projects.projects_data.forEach((projectValues, projectIndexing) => {
                  var perProductTotalPrintingCost = 0;
                  var thisProjectTotalCost = 0;
                  if (projectValues.perProductPriceDistributionData) {
                    //Calculate print price per piece
                    this.projects.projects_data[projectIndexing].perProductPriceDistributionData.forEach((values) => {
                      thisProjectTotalCost = thisProjectTotalCost + (projectValues.totalProjectQuantity ? projectValues.totalProjectQuantity : 0) * (values.perProductTotalCost ? values.perProductTotalCost : 0);
                      perProductTotalPrintingCost = perProductTotalPrintingCost + values.perProductTotalPrintingCost;
                      this.projects.projects_data[this.activeProjectIndex].perProductTotalPrintingCost = perProductTotalPrintingCost;
                    });
                  }
                  else if (projectValues.priceDistributionData) {
                    this.projects.projects_data[projectIndexing].priceDistributionData.forEach((values) => {
                      thisProjectTotalCost = thisProjectTotalCost + (projectValues.totalProjectQuantity ? projectValues.totalProjectQuantity : 0) * (values.perProductTotalCost ? values.perProductTotalCost : 0);
                      perProductTotalPrintingCost = perProductTotalPrintingCost + values.perProductTotalPrintingCost;
                      this.projects.projects_data[this.activeProjectIndex].perProductTotalPrintingCost = perProductTotalPrintingCost;
                    });
                  }
                  else {
                    whenPriceFound = false;
                  }
                  //Calculate price per piece
                  if (projectValues.priceMarkupProduct) {
                    let priceMarkupProduct = projectValues.priceMarkupProduct;
                    let products = this.projects.projects_data[projectIndexing].products;
                    this.updatePriceInProductsMatrix(priceMarkupProduct, products, perProductTotalPrintingCost, projectIndexing);
                  }
                  else {
                    whenPriceFound = false;
                  }
                  if (!projectValues.perProjectTotalCost) {
                    if (projectValues.total_price) {
                      this.projects.projects_data[projectIndexing].perProjectTotalCost = projectValues.total_price.toFixed(2);
                    } else {
                      this.projects.projects_data[projectIndexing].perProjectTotalCost = thisProjectTotalCost.toFixed(2);
                    }
                  }
                });
                if (!whenPriceFound) {
                  this.priceOverride();
                }
              }
              if (this.prevPrice == 0) {
                this.prevPrice = obj.data.grand_total_price;
              }
              this.grandTotalPrice = response.data.grand_total_price;
              this.showConfirmMessage();
              this.totalProjectQuantity[this.activeProjectIndex] = this.projects.total_quantity;
              this.CommonProjectDataService.store(this.projects);
              this.CommonProjectDataService.storeTotalPrice(response.data.grand_total_price);

              this.CommonProjectDataService.storeTotalProjectQuantity(this.totalProjectQuantity);
              if (this.projects.order_id) {
                this.CommonProjectDataService.storeDeliveryDate(response.data.delivery_date);
                this.scheduledDate = response.data.scheduled_date ? response.data.scheduled_date : '';
                this.CommonProjectDataService.storeScheduledDate(this.scheduledDate);
                this.CommonProjectDataService.storeOrderId(this.projects.order_id);
                const clientName = (this.projects.user_first_name) ? this.projects.user_first_name + ' ' + this.projects.user_last_name : ' ';
                this.CommonProjectDataService.storeClientName(clientName);
                if (!this.projects.user_company_name) {
                  this.CommonProjectDataService.storeCompanyName(this.projects.user_company_name);
                }
                else {
                  this.CommonProjectDataService.storeCompanyName('');
                }
                this.dueDateForm.controls.dueDate.setValue(new Date(response.data.delivery_date));
              }
            }

            if (this.projects.custom_order_id) {
              this.customOrderId = this.projects.custom_order_id;
              this.CommonProjectDataService.storeCustomOrderId(this.projects.custom_order_id);
            }

            if (this.projects.paid_amount) {
              this.balanceAmount = (this.projects.grand_total_price - this.projects.paid_amount);
            }
            else {
              this.balanceAmount = (this.projects.grand_total_price);
            }
            if (this.projects.refunded_amount) {
              this.balanceAmount += Number(this.projects.refunded_amount);
            }
            if (this.isPayment == 'Yes' && this.balanceAmount == 0 && this.projects.net_days > 0) {
              this.CommonProjectDataService.receivableCount.next(this.receivableCount - 1);
              this.userDetails.receivable_count = this.receivableCount;
              localStorage.setItem("userDetails", JSON.stringify(this.userDetails));
            }

            this.assignStatus = this.projects.status;
            // show printer and shopadmin assing status list
            this.mockupAssignStatus();
            if (this.addProductStepComponent) {
              this.addProductStepComponent.refreshData();
            }
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  showSquareupResponseDialog(data: any) {
    if (localStorage.getItem('squarePaymentData') && (localStorage.getItem('squarePaymentData') == 'true')) {
      localStorage.removeItem('squarePaymentData');
      if (data.SquareupPayment) {
        if ((data.SquareupPayment.amount) && (data.SquareupPayment.transaction_id) && (data.SquareupPayment.receipt_url)) {
          const dialogRef = this.dialog.open(SquareupResponseComponent, {
            width: "500px",
            disableClose: true,
            data: {
              transactionID: data.SquareupPayment.transaction_id,
              amount: data.SquareupPayment.amount,
              receiptUrl: data.SquareupPayment.receipt_url,
              isPublic: false
            }
          });
          dialogRef.afterClosed().subscribe(result => {
          });
        }
      }
    }
    else if(localStorage.getItem('cardPaymentData')) {
      const cardPaymentData = JSON.parse(localStorage.getItem("cardPaymentData"));
      localStorage.removeItem('cardPaymentData');
      if(cardPaymentData && cardPaymentData.paymentType && cardPaymentData.amount && cardPaymentData.transactionId) {
        if(cardPaymentData.paymentType == 'Card' && cardPaymentData.amount > 0 && cardPaymentData.transactionId != '') {
          const dialogRef = this.dialog.open(SquareupResponseComponent, {
            width: "500px",
            disableClose: true,
            data: {
              transactionID: cardPaymentData.transactionId,
              amount: cardPaymentData.amount,
              receiptUrl: '',
              isPublic: false
            }
          });
          dialogRef.afterClosed().subscribe(result => {
          });
        }
      }
    }
  }

  mockupAssignStatus() {
    let currentIndex = this.jobStatusLists.findIndex(x => x.sKey == 'Print Production');
    if (this.projects.shipping_method_key == 'local_pickup') {
      this.jobStatusLists[currentIndex + 1] = ({ sKey: "Ship | Local Pickup", sValue: "Local Pickup" });
    }
    else {
      let currentIndex = this.jobStatusLists.findIndex(x => x.sKey == 'Print Production');
      this.jobStatusLists[currentIndex + 1] = ({ sKey: "Ship | Local Pickup", sValue: "Ship" });
    }
    this.jobStatusLists[currentIndex + 2] = ({ sKey: "Complete", sValue: "Complete" })

    if (this.userDetails.type == 'Printer') {
      this.jobStatusLists.splice(0, 4);
    }
    if (this.userDetails.type == 'Designer') {
      this.jobStatusLists.splice(0, 2);
      this.jobStatusLists.splice(2, 5);
    }
  }

  totalQuantity = function (rowArr) {
    if (Object.keys(rowArr).length > 0) {
      return rowArr.reduce(function (a, b) {
        return a + b;
      }, 0);
    }
    else {
      return 0;
    }
  }

  backToList(): void {
    if (this.activateroute.snapshot.params["id"] || this.activateroute.snapshot.params["invoiceID"]) {
      this.router.navigate(["/invoices"]);
    }
    else {
      this.toggleForm.emit();
    }
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  sendEmail = function () {
    this.loading = true;
    let mailoption = {
      id: localStorage.getItem("userID"),
      invoice_id: this.id
    };
    this.CommonService.apiService(
      "POST",
      "email/invoice",
      mailoption
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 5000
          });
        }
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
      }
    );
  }

  ShowArtworkDialog(artwork, mockupData, printPosition, artFileInkcolor, pkey, printLoc, mockupFileName, userId): void {
    this.saveQuoteData(true);
    const dialogRef = this.dialog.open(InvoiceItemComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        item_type: '',
        artworkFiles: artwork,
        mockupDataFiles: mockupData,
        mockupFileName: mockupFileName,
        printLocation: printLoc,
        printPosition: printPosition,
        artFileInkcolor: artFileInkcolor,
        userId: userId,
        artMockupData: { invoiceId: this.projects.order_id, projectKey: pkey, projectStatus: this.projects.status },
        orderType: this.orderType
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.getOrderList();
      }
    });
  }

  saveArtFile(artFileData, printLoc) {
    let projectData = this.projects.projects_data[this.activeProjectIndex];
    if (!this.projects.projects_data[this.activeProjectIndex].artwork) {
      this.projects.projects_data[this.activeProjectIndex] = {
        artwork: { [printLoc]: artFileData }
      }
      this.validateProjectData();
    }
    else {
      if (this.projects.projects_data[this.activeProjectIndex].artwork) {
        if (this.projects.projects_data[this.activeProjectIndex].artwork[printLoc]) {
          Object.assign(this.projects.projects_data[this.activeProjectIndex].artwork[printLoc], artFileData);
        }
        else {
          if (this.projects.projects_data[this.activeProjectIndex].artwork.length == 0) {
            this.projects.projects_data[this.activeProjectIndex].artwork = { [printLoc]: artFileData };
          }
          else {
            this.projects.projects_data[this.activeProjectIndex].artwork[printLoc] = artFileData;
          }
        }
      }
      this.validateProjectData();
    }
  }

  showMockupMessage(mockupMessageData, imgSrc, locs, finishingDetails, pkey): void {
    const dialogRef = this.dialog.open(InvoiceItemComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        assignStatus: this.projects.status,
        mockupMessageData: mockupMessageData,
        active_artwork_loc: locs.emblocation_id,
        mockup_img: imgSrc,
        finishingDetails: finishingDetails,
        activeMockupData: { invoiceId: this.projects.order_id, projectKey: pkey, printLocs: locs.emblocation_id, locName: locs.name }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (this.id != "order" || result == "success") {
        this.getOrderList();
      }
    });
  }

  showInkChangeDialog(inkChange, selectedInkColorObj, locs, active_image_loc): void {
    if (inkChange) {
      const dialogRef = this.dialog.open(InvoiceItemComponent, {
        width: "800px",
        disableClose: true,
        data: {
          inkChangeData: inkChange,
          active_artwork_loc: locs,
          selectedInkColorObj: selectedInkColorObj,
          active_image_loc: active_image_loc
        }
      });

      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  showCustomNameNumberDialog(products, otherPrintSettings, locs): void {
    const dialogRef = this.dialog.open(InvoiceItemComponent, {
      width: "800px",
      disableClose: true,
      data: {
        productsData: products,
        active_artwork_loc: locs,
        otherPrintSettings: otherPrintSettings
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }



  openCheckOutDialog() {
    const dialogRef = this.dialog.open(CheckOutComponent, {
      width: "600px",
      disableClose: true,
      data: {
        user_id: this.projects.user_id,
        amount: this.orderType == 'Quote' ? this.projects.grand_total_price : this.balanceAmount,
        paidAmount: this.projects.paid_amount,
        order_id: this.projects.order_id,
        manageData: { guest_email: '' },
        order_instructions_payment: this.projects.order_instructions_payment,
        order_instruction_title: this.projects.order_instruction_title,
        paypal_payment_enable: this.projects.paypal_payment_enable,
        paypal_payment_api_key: this.projects.paypal_payment_api_key,
        turnAroundTimes: this.turnAroundTimes,
        turn_around_time: this.projects.turn_around_time_key ? this.projects.turn_around_time_key : 0,
        shipping_method: this.projects.shipping_method_key ? this.projects.shipping_method_key : "local_pickup",
        shipping: this.shipping,
        is_payment_term: this.is_payment_term,
        projects: this.projects,
        shippingAddress: this.address,
        turnAroundName: this.turnAroundName,
        cc_payment_enable: this.projects.cc_payment_enable,
        cc_payment_api: this.projects.cc_payment_api,
        orderType: this.orderType,
        isShippingOption: this.isShippingOption,
        isLocalPickupOption: this.isLocalPickupOption,
        cardProcessingFees: this.cardProcessingFees,
        isConnectQBO: this.isConnectQBO,
        scheduledDate: this.scheduledDate
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        if (this.projects.type == "Invoice") {
          this.isPayment = 'Yes';
          this.getOrderList();
        }
        else {
          this.router.navigateByUrl('/RefrshComponent', { skipLocationChange: true }).then(() =>
            this.router.navigate(["/invoices/" + this.projects.order_id]));
        }
      }
    });
  }

  onPrint() {
    let showAddressOnprint = this.isShowAddress;
    this.isPackingSlip = false;

    if (showAddressOnprint == false) {
      this.isShowAddress = true;
    }
    setTimeout(() => {
      window.print();
      if (showAddressOnprint == false) {
        this.isShowAddress = false;
      }
    });

  }

  printPackingSlip() {
    this.isPackingSlip = true;
    let showAddressOnprint = this.isShowAddress;
    if (showAddressOnprint == false) {
      this.isShowAddress = true;
    }
    setTimeout(() => {
      window.print();
      if (showAddressOnprint == false) {
        this.isShowAddress = false;
      }
    }, 500);
  }

  onJobStatusChange = function (jobStatus) {
    this.projects.status = jobStatus;

    let jobData = {
      'id': localStorage.getItem("userID"),
      'invoice_id': this.id == 'order' ? this.projects.order_id : this.id,
      'status': jobStatus
    };
    this.loading = true;
    this.CommonService.apiService(
      "POST",
      "job/status",
      jobData
    ).subscribe(
      (response: any) => {
        this.loading = false;
        this.previousStatus = this.projects.status;
        if (response.status === true) {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 2000
          });
        }
        window.scrollTo(0, 0);
      },
      err => {
        this.loading = false;
        this.projects.status = this.previousStatus;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        })
      }
    );
  };

  assignStaff = function (eventData, invoiceID) {
    let staffId = eventData.target.value;
    let staffTypeId = eventData.target.name;
    let staffType = (eventData.target.name == 'designer_id') ? 'designer' : 'printer';

    this.projects[staffTypeId] = staffId;

    if (staffId) {
      this.loading = true;
      let statusOptions = {
        id: localStorage.getItem("userID"),
        [staffTypeId]: staffId,
        invoice_id: invoiceID
      };
      this.CommonService.apiService(
        "POST",
        "job/assign/" + staffType,
        statusOptions
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 3000
            });
          }
        },
        err => {
          this.loading = false;
          console.log(err);
        }
      );
    }
  }
  addSectionRow(sectionItems: Array<any>) {
    sectionItems.push({
      'lable': "Section Title Click to Edit",
      'custom_items': [
        {
          item: "",
          price: "0",
          quantity: "0",
          description: ""
        }
      ]
    });
  }

  copySectionRow(sectionItems: Array<any>, index) {
    let sectionData = sectionItems[index];

    // Check if the section data has custom items and if they exist, remove mockups
    if (sectionData.custom_items && sectionData.custom_items.length > 0) {
      for (let i = 0; i < sectionData.custom_items.length; i++) {
        if (sectionData.custom_items[i].mockups) {
          delete sectionData.custom_items[i].mockups;
        }
      }
    }

    const section = JSON.parse(JSON.stringify(sectionData)); 
    sectionItems.push(section);
    this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
    this.getPrice();
  }

  deleteSectionRow(sectionItems: Array<any>, index) {
    sectionItems.splice(index, 1);
    this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
    this.getPrice();
  }

  addListRow(customeItems: Array<any>, index) {
    customeItems.push({
      item: "",
      price: "0",
      quantity: "0",
      description: ""
    });
    this.customItemError = true;
    this.quantityError = true;
  }
  copyListRow(customeItems: Array<any>, index) {
    this.customeLineItemError = "";
    if (customeItems[index].item == "") {
      this.customeLineItemError = "Please enter Item Name";
      this._flashMessagesService.show(this.customeLineItemError, { cssClass: 'alert-warning', timeout: 5000 });
      return;
    }
    if (customeItems[index].price == 0) {
      this.customeLineItemError = "Price must be greater than 0";
      this._flashMessagesService.show(this.customeLineItemError, { cssClass: 'alert-warning', timeout: 5000 });
      return;
    }
    if (customeItems[index].quantity == 0) {
      this.customeLineItemError = "Quantity must be than 0";
      this._flashMessagesService.show(this.customeLineItemError, { cssClass: 'alert-warning', timeout: 5000 });
      return;
    }
    if (this.customeLineItemError == "") {
      customeItems.push({
        item: customeItems[index].item,
        price: customeItems[index].price,
        quantity: customeItems[index].quantity,
        description: customeItems[index].description
      });
      this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
      this.getPrice();
    }
    this.customItemError = true;
    this.quantityError = true;
  }

  deleteListRow(customeItems: Array<any>, index, pkey) {
    let firstCustomeItem = JSON.parse(JSON.stringify(customeItems));
    customeItems.splice(index, 1);
    if (firstCustomeItem[index].price > 0 && firstCustomeItem[index].quantity > 0) {
      this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
      this.getPrice();
    }
  }

  showReplyButton(displayStatus) {
    this.isReplyButton = displayStatus;
    this.isCommentBox = !displayStatus;
  }

  isReplyValid(cStatus) {
    return (cStatus == 'Complete' || cStatus == 'Cancel') ? false : true;
  }

  openReplyBox(isOpenComments, printLocs) {
    this.isOpenComments = {}
    this.isOpenComments[printLocs] = !isOpenComments;
    this.currentMessage[printLocs] = {
      invoice: ''
    };
  }

  sendReply = function (pKey, printLocs, msgType) {
    this.loading = true;
    let projectKey = pKey + 1;
    let msgKey = (msgType == 'invoice') ? 'comments' : (msgType == 'revision') ? 'revisions' : 'mockup_approval_notes';
    let messageOptions = {
      id: localStorage.getItem("userID"),
      invoice_id: this.id == 'order' ? this.projects.order_id : this.id,
      project: projectKey,
      location: printLocs,
      message: this.currentMessage[printLocs][msgType]
    }

    if (this.currentMessage[printLocs][msgType]) {
      this.CommonService.apiService(
        "POST",
        "invoice/message",
        messageOptions
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {

            if (msgType == 'mockup_approval_notes') {
              this.projects.projects_data[pKey].messages[printLocs][msgKey] = {
                message: this.currentMessage[printLocs][msgType],
                first_name: this.userDetails.first_name,
                last_name: this.userDetails.last_name,
                created_at: new Date(),
                type: this.userDetails.type,
                profile_img: this.userDetails.profile_img
              };
            }
            else {

              if (this.projects.projects_data[pKey].messages && this.projects.projects_data[pKey].messages[printLocs] && this.projects.projects_data[pKey].messages[printLocs][msgKey]) {
                this.projects.projects_data[pKey].messages[printLocs][msgKey].unshift({
                  message: this.currentMessage[printLocs][msgType],
                  first_name: this.userDetails.first_name,
                  last_name: this.userDetails.last_name,
                  created_at: new Date(),
                  type: this.userDetails.type,
                  profile_img: this.userDetails.profile_img
                });
              }
              else {

                if (this.projects.projects_data[pKey].messages && this.projects.projects_data[pKey].messages[printLocs]) {
                  Object.assign(this.projects.projects_data[pKey].messages[printLocs], {
                    [msgKey]: [{
                      message: this.currentMessage[printLocs][msgType],
                      first_name: this.userDetails.first_name,
                      last_name: this.userDetails.last_name,
                      created_at: new Date(),
                      type: this.userDetails.type,
                      profile_img: this.userDetails.profile_img
                    }]

                  });
                }
                else if (this.projects.projects_data[pKey].messages) {
                  Object.assign(this.projects.projects_data[pKey].messages, {
                    [printLocs]: {
                      [msgKey]: [{
                        message: this.currentMessage[printLocs][msgType],
                        first_name: this.userDetails.first_name,
                        last_name: this.userDetails.last_name,
                        created_at: new Date(),
                        type: this.userDetails.type,
                        profile_img: this.userDetails.profile_img
                      }]
                    }

                  });
                }
                else if (!this.projects.projects_data[pKey].messages) {
                  Object.assign(this.projects.projects_data[pKey], {
                    messages: {
                      [printLocs]: {
                        [msgKey]: [{
                          message: this.currentMessage[printLocs][msgType],
                          first_name: this.userDetails.first_name,
                          last_name: this.userDetails.last_name,
                          created_at: new Date(),
                          type: this.userDetails.type,
                          profile_img: this.userDetails.profile_img
                        }]
                      }
                    }
                  });
                }
              }
            }
            this.currentMessage = {};
            this.isOpenComments = {};
            this._flashMessagesService.show(response.message, { cssClass: 'alert-success', timeout: 5000 });
          }
        },
        err => {
          this.loading = false;
          console.log(err);
        }
      );
    }
  }

  checkCustomItems = function (pKey, projectsData) {
    let checkStatusArr = ['Assign', 'Generate Mockups', 'Mockups Submitted'];
    if (checkStatusArr.indexOf(this.projects.status) >= 0) {
      this.lineItemdisabled = false;
    }
    if (!projectsData.custom_items || (projectsData.custom_items && projectsData.custom_items.length == 0)) {
      Object.assign(this.projects.projects_data[pKey], { custom_items: [{ item: '', price: 0, quantity: 0, description: '' }] })
      this.quantityError = true;
      this.customItemError = true;
    }
    return this.projects.projects_data[pKey].custom_items;
  }

  checkSectionCustomItems = function (pKey, projectsData) {
    if (projectsData.custom_items && projectsData.custom_items.length > 0) {
      this.projects.projects_data[pKey]['section_items'] = [{
        'lable': "Section Title Click to Edit",
        'custom_items': projectsData.custom_items
      }];
    }
    if (projectsData.custom_items) {
      delete this.projects.projects_data[pKey].custom_items;
    }
    if (!this.projects.projects_data[pKey].section_items) {
      this.projects.projects_data[pKey]['section_items'] =
        [
          {
            'lable': "Section Title Click to Edit",
            'custom_items': [
              {
                item: "",
                price: "0",
                quantity: "0",
                description: ""
              }
            ]
          }
        ]
    }
    if (this.projects.projects_data[pKey].section_items && this.projects.projects_data[pKey].section_items.length == 0) {
      this.projects.projects_data[pKey]['section_items'].push(
        {
          'lable': "Section Title Click to Edit",
          'custom_items': [
            {
              item: "",
              price: "0",
              quantity: "0",
              description: ""
            }
          ]
        }
      )
    }
    return this.projects.projects_data[pKey].section_items;
  }


  saveCustomeItems = function (pKey, customeItems: Array<any>) {
    this.loading = true;
    let projectKey = pKey + 1;
    let customeItemOptions = {
      id: localStorage.getItem("userID"),
      invoice_id: this.id,
      project: projectKey,
      custom_items: customeItems
    }

    this.CommonService.apiService(
      "POST",
      "invoice/manage_custom_items",
      customeItemOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this._flashMessagesService.show(response.message, { cssClass: 'alert-success', timeout: 5000 });
          this.getOrderList();
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  getPrice = function () {
    let projects = this.tempProjectData;
    let user_id = this.projects.user_id;
    let finalArr = []

    projects.forEach((pvalue, pkey) => {
      let activeLoc = pvalue.active_location_arr;
      let projectTitle = (pvalue.projectTitle) ? pvalue.projectTitle : "";
      if (sessionStorage.getItem(`projectTitle_${pkey}`)) {
        projectTitle = sessionStorage.getItem(`projectTitle_${pkey}`);
      }
      let isCheckedProjectTab = (pvalue.isCheckedProjectTab) ? pvalue.isCheckedProjectTab : "";
      let totalPriceCalculation = (pvalue.totalPriceCalculation) ? pvalue.totalPriceCalculation : false;
      if (pvalue.products && pvalue.products.length > 0) {
        pvalue.products.forEach((product, key) => {
          if (finalArr[pkey] && finalArr[pkey].products) {
            Object.assign(finalArr[pkey].products, { [product.product_id]: {} });
            Object.assign(finalArr[pkey].products_matrix, { [product.product_id]: {} });
          }
          else {
            finalArr[pkey] = {
              'products': { [product.product_id]: {} },
              'products_matrix': { [product.product_id]: {} },
              'printPositionSetting': pvalue.printPositionSetting,
              'finishingDetails': (pvalue.finishing_type_id) ? pvalue.finishing_type_id : [],
              'inkDetail': (pvalue.ink_Details && pvalue.ink_Details.ink_type_id) ? pvalue.ink_Details.ink_type_id : null,
              'section_items': pvalue.section_items,
              'isCheckedProjectTab': isCheckedProjectTab,
              'projectTitle': projectTitle,
              'productsMatrixData': pvalue.products,
              'totalPriceCalculation': totalPriceCalculation
            };
          }
          finalArr[pkey].ownGarmentsWeight = pvalue.ownGarmentsWeight;
          // set inkColors under printPositionSetting
          if (activeLoc && activeLoc.length > 0) {
            activeLoc.forEach((lval, lkey) => {
              if (pvalue.inkColors && pvalue.inkColors[lval.emblocation_id]) {
                let tmpInkColor = (pvalue.inkColors[lval.emblocation_id]) ? pvalue.inkColors[lval.emblocation_id] : [];
                if (pvalue.printPositionSetting[lval.emblocation_id]) {
                  pvalue.printPositionSetting[lval.emblocation_id]['inkColors'] = tmpInkColor;
                }
                else {
                  pvalue.printPositionSetting[lval.emblocation_id] = { ['inkColors']: tmpInkColor };
                }
              }
              // set printAddonSetting under printPositionSetting
              if (pvalue.printAddonSetting) {
                if (pvalue.printPositionSetting[lval.emblocation_id]) {
                  pvalue.printPositionSetting[lval.emblocation_id]['printAddonSetting'] = (pvalue.printAddonSetting[lval.emblocation_id]) ? pvalue.printAddonSetting[lval.emblocation_id] : {};
                }
              }
              // set inkChangeData under printPositionSetting
              if (pvalue.inkChangeData) {
                if (pvalue.printPositionSetting[lval.emblocation_id]) {

                  if (pvalue.inkChangeData[lval.emblocation_id]) {
                    pvalue.printPositionSetting[lval.emblocation_id]['inkChangeData'] = this.processInkChangeData(pvalue.inkChangeData[lval.emblocation_id]);
                  }
                  else {
                    pvalue.printPositionSetting[lval.emblocation_id]['inkChangeData'] = [];
                  }
                }
              }
              if (pvalue.artwork) {
                let artTmp = Object.keys(pvalue.artwork).length;
              }
              finalArr[pkey].printPositionSetting = pvalue.printPositionSetting;
              product.matrix.forEach(function (mval, mkey) {
                if (finalArr[pkey].products[product.product_id]) {
                  Object.assign(finalArr[pkey].products[product.product_id], { [mval.color.color_id]: {}, type: product.productDetail.type });
                  Object.assign(finalArr[pkey].products_matrix[product.product_id], { [mval.color.color_id]: mval.matrix_id });
                }
                else {
                  finalArr[pkey].products[product.product_id] = { [mval.color.color_id]: {}, type: product.productDetail.type };
                  finalArr[pkey].products_matrix[product.product_id] = { [mval.color.color_id]: mval.matrix_id };
                }
                mval.quantity.forEach(function (qval, qkey) {

                  if (qval && qval > 0) {
                    if (finalArr[pkey].products[product.product_id][mval.color.color_id]) {
                      Object.assign(finalArr[pkey].products[product.product_id][mval.color.color_id], { [mval.size[qkey].size_id]: qval });
                    }
                    else {
                      finalArr[pkey].products[product.product_id][mval.color.color_id] = { [mval.size[qkey].size_id]: qval };
                    }
                  }
                });
              });

            });
          }
          else {
            product.matrix.forEach(function (mval, mkey) {
              if (finalArr[pkey].products[product.product_id]) {
                Object.assign(finalArr[pkey].products[product.product_id], { [mval.color.color_id]: {}, type: product.productDetail.type });
                Object.assign(finalArr[pkey].products_matrix[product.product_id], { [mval.color.color_id]: mval.matrix_id });
              }
              else {
                finalArr[pkey].products[product.product_id] = { [mval.color.color_id]: {}, type: product.productDetail.type };
                finalArr[pkey].products_matrix[product.product_id] = { [mval.color.color_id]: mval.matrix_id };
              }
              mval.quantity.forEach(function (qval, qkey) {
                if (qval && qval > 0) {
                  if (finalArr[pkey].products[product.product_id][mval.color.color_id]) {
                    Object.assign(finalArr[pkey].products[product.product_id][mval.color.color_id], { [mval.size[qkey].size_id]: qval });
                  }
                  else {
                    finalArr[pkey].products[product.product_id][mval.color.color_id] = { [mval.size[qkey].size_id]: qval };
                  }
                }
              });
            });
          }
        });
      }
      else {
        finalArr[pkey] = {
          'section_items': pvalue.section_items,
          'isCheckedProjectTab': isCheckedProjectTab,
          'projectTitle': projectTitle
        }
      }

    });
    let otherData = {
      user_id: this.projects.user_id ? this.projects.user_id : '',
      address_id: (this.projects.shipping_address && this.projects.shipping_address.address_id) ? this.projects.shipping_address.address_id : this.projects.address_id ? this.projects.address_id : '',
      turn_around_time: this.projects.turn_around_time_key ? this.projects.turn_around_time_key : 0,
      shipping_method: this.projects.shipping_method_key ? this.projects.shipping_method_key : "local_pickup"
    }
    let quoteOpt = {
      id: this.shopId,
      projects_data: finalArr,
      user_id: otherData.user_id,
      address_id: otherData.address_id,
      turn_around_time: otherData.turn_around_time,
      shipping_method: otherData.shipping_method,
      one_time_discount_type: this.projects.one_time_discount_type ? this.projects.one_time_discount_type : '',
      one_time_discount: this.projects.one_time_discount ? this.projects.one_time_discount : 0
    };

    this.CommonService.apiService(
      "POST",
      "v3/order/get_prices",
      quoteOpt
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.projects.delivery_date = this.orderType == 'Quote' ? response.data.delivery_date : this.projects.delivery_date;
          this.projects.delivery_date = (this.orderType == 'Quote' && this.scheduledDate) ? this.scheduledDate : this.projects.delivery_date
          this.projects.delivery_days = response.data.delivery_days;
          this.projects.discount = response.data.discount;
          this.projects.discount_percentage = response.data.discount_percentage;
          this.projects.grand_total_price = response.data.grand_total_price;
          this.projects.shipping_price = response.data.shipping_price;
          this.projects.tax = response.data.tax;
          this.projects.tax_exempt = response.data.tax_exempt ? response.data.tax_exempt : false;
          this.projects.tax_percentage = response.data.tax_percentage;
          this.projects.total_price = response.data.total_price;
          this.projects.total_printing_price = response.data.total_printing_price;
          this.projects.total_products_price = response.data.total_products_price;
          this.projects.total_quantity = response.data.total_quantity;
          this.projects.total_weight = response.data.total_weight;
          this.projects.turn_around_time_price = response.data.turn_around_time_price;
          this.projects.total_projects = response.data.total_projects;
          this.projects.total_custom_items_price = response.data.total_custom_items_price;
          this.projects.turn_around_time = '0';
          this.projects.paypal_payment_enable = response.data.paypal_payment_enable;
          this.projects.paypal_payment_api_key = response.data.paypal_payment_api_key;
          this.projects.cc_payment_enable = response.data.cc_payment_enable;
          this.projects.cc_payment_api = response.data.cc_payment_api;
          this.projects.per_product_price_distribution = response.data.per_product_price_distribution;

          this.projects.one_time_discount = response.data.one_time_discount;
          this.projects.one_time_discount_type = response.data.one_time_discount_type;
          this.projects.one_time_discounted_amt = response.data.one_time_discounted_amt;
          this.grandTotalPrice = response.data.grand_total_price;

          if (this.prevPrice == 0 && this.projects.order_id) {
            this.prevPrice = this.grandTotalPrice;
          }
          this.showConfirmMessage();
          this.totalProjectQuantity[this.activeProjectIndex] = response.data.projects[this.activeProjectIndex].total_quantity;
          // set  printing price  per project
          this.projects.projects_data[this.activeProjectIndex].total_printing_price = response.data.projects[this.activeProjectIndex].total_printing_price;
          this.projects.projects_data[this.activeProjectIndex].projectTitle = response.data.projects[this.activeProjectIndex].projectTitle;
          this.projects.projects_data[this.activeProjectIndex].priceMarkupProduct = response.data.projects[this.activeProjectIndex].priceMarkupProduct;
          response.data.projects.forEach((projectValues, projectIndexing) => {
            this.projects.projects_data[projectIndexing].perProjectTotalCost = projectValues.perProjectTotalCost;
            this.projects.projects_data[projectIndexing].products = projectValues.productsMatrixData;
            this.projects.projects_data[projectIndexing].priceDistributionData = projectValues.perProductPriceDistributionData;
            this.projects.projects_data[projectIndexing].projectTitle = projectValues.projectTitle;
          });

          if (this.type != "Duplicate") {
            localStorage.setItem("totalPrice", this.projects.grand_total_price);
            let username = this.projects.user_first_name ? this.projects.user_first_name : 'Guest';
            localStorage.setItem('userName', username);
            localStorage.setItem('clientId', this.projects.user_id);
          }
          this.CommonProjectDataService.storeTotalProjectQuantity(this.totalProjectQuantity);
          this.CommonProjectDataService.storeTotalPrice(response.data.grand_total_price);
          if (this.projects.order_id) {
            this.CommonProjectDataService.storeDeliveryDate(this.projects.delivery_date);
            this.CommonProjectDataService.storeOrderId(this.projects.order_id);
            const clientName = (this.projects.user_first_name) ? this.projects.user_first_name + ' ' + this.projects.user_last_name : ' ';
            this.CommonProjectDataService.storeClientName(clientName);
            if (this.projects.user_company_name) {
              this.CommonProjectDataService.storeCompanyName(this.projects.user_company_name);
            }
            else {
              this.CommonProjectDataService.storeCompanyName('');
            }
            this.dueDateForm.controls.dueDate.setValue(new Date(this.projects.delivery_date));
          }
          if (this.projects.custom_order_id) {
            this.customOrderId = this.projects.custom_order_id;
            this.CommonProjectDataService.storeCustomOrderId(this.projects.custom_order_id);
          }
          if (response.data.addresses.length > 0) {
            this.address = response.data.addresses;
          }
          if (response.data.turn_around_times.length > 0) {
            this.turnAroundTimes = response.data.turn_around_times;
          }
          if (otherData.shipping_method == "local_pickup") {
            this.projects.shipping_method = response.data.shipping_methods.local_pickup;
          }

          // Open price override && loader
          this.priceOverrideLoading = false;
          this.hideAllEditIcon = false;
          if (Object.keys(this.priceOverrideLocation).length > 0) {
            if (this.projects.projects_data[this.activeProjectIndex]) {
              if (this.projects.projects_data[this.activeProjectIndex].products[this.priceOverrideLocation.productIndex]) {
                if (this.projects.projects_data[this.activeProjectIndex].products[this.priceOverrideLocation.productIndex].matrix[this.priceOverrideLocation.matrixIndex]) {
                  this.projects.projects_data[this.activeProjectIndex].products[this.priceOverrideLocation.productIndex].matrix[this.priceOverrideLocation.matrixIndex].openPriceEdit = new Array(this.projects.projects_data[this.activeProjectIndex].products[this.priceOverrideLocation.productIndex].matrix[this.priceOverrideLocation.matrixIndex].size.length).fill(null);
                  this.projects.projects_data[this.activeProjectIndex].products[this.priceOverrideLocation.productIndex].matrix[this.priceOverrideLocation.matrixIndex].openPriceEditLoader = new Array(this.projects.projects_data[this.activeProjectIndex].products[this.priceOverrideLocation.productIndex].matrix[this.priceOverrideLocation.matrixIndex].size.length).fill(null);
                }
              }
            }
            this.priceOverrideLocation = {};
          }

          this.CommonProjectDataService.store(this.projects);
          this.shipping = [];
          Object.entries(response.data.shipping_methods).forEach(
            ([skey, value]) => {
              this.shipping.push(
                {
                  key_value: skey,
                  name: value
                });
            });
          this.loading = false;
          if (this.isShowCheckout)
            this.openCheckOutDialog();

          // Check if the current invoice requires a price override
          if (this.isPriceOverrideInvoice) {
            if (this.projects.paid_amount) {
              this.balanceAmount = (this.projects.grand_total_price - this.projects.paid_amount);
            }
            else {
              this.balanceAmount = (this.projects.grand_total_price);
            }
            if (this.projects.refunded_amount) {
              this.balanceAmount += Number(this.projects.refunded_amount);
            }
            this.isPriceOverrideInvoice = false;
          }
          if(this.isRebindPriceOverview){
            localStorage.setItem("isRebindPriceOverview", 'true');
            this.isRebindPriceOverview = false;
          }
        }
      },
      err => {
        this.loading = false;
        console.log("error msg", err.error.message);
      }
    );
  }

  processInkChangeData(inkData) {
    let tmpArr = [];
    inkData.updData.forEach((val, key) => {
      tmpArr[key] = { 'inkColors': [] };
    });

    Object.values(inkData.colorChange).forEach((val, key) => {
      Object.entries(val).forEach(
        ([pkey, value]) => {
          if (tmpArr[key].inkColors) {
            tmpArr[key].inkColors.push(val[pkey].upd.ink_id);
          }
          else {
            tmpArr[key] = { inkColors: [val[pkey].upd.ink_id] };
          }
        }
      );
    });
    return tmpArr;
  }

  filterArrayData(tmpArr, arrKey) {
    if (tmpArr && tmpArr.new_hex) {
      tmpArr.new_hex.forEach(function (val, index) {
        if (val == '#00FFFFFF') {
          tmpArr.new_hex_obj[index] = { 'ink_id': '#00FFFFFF' };
        }
      });
      return tmpArr.new_hex_obj.reduce(function (map, tag) {
        if (map.length > 0) {
          map.push(tag[arrKey]);
        }
        else {
          map = [tag[arrKey]];
        }
        return map;
      }, {});
    }
    else {
      return [];
    }
  }

  costValidate = function (amount, quantity) {
    if (amount == 0) {
      if (quantity > 0) {
        this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
        this.getPrice();
      }
      this.customeLineItemError = "amount must be greater than 0";
      this._flashMessagesService.show(this.customeLineItemError, { cssClass: 'alert-warning', timeout: 5000 });
      return;
    }
    if (amount != '' && quantity != '') {
      if (amount > 0 && quantity > 0) {
        this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
        this.getPrice();
      }
    }
  }

  quantityValidate = function (amount, quantity) {
    if (quantity == 0) {
      if (amount > 0) {
        this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
        this.getPrice();
      }
      this.customeLineItemError = "Quantity must be greater than 0";
      this._flashMessagesService.show(this.customeLineItemError, { cssClass: 'alert-warning', timeout: 5000 });
      return;
    }
    if (amount != '' && quantity != '') {
      if (amount > 0 && quantity > 0) {
        this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
        this.getPrice();
      }
    }
  }

  ItemNameValidate = function (items) {
    this.lineItemError = items.item == '' ? true : false;
    if (items.item == "") {
      if (items.quantity > 0 && items.price > 0) {
        items.quantity = 0;
        items.price = 0;
        this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
        this.getPrice();
      }
      else {
        items.quantity = 0;
        items.price = 0;
      }
      items.description = '';
      this.customeLineItemError = "Please enter Item Name";
      this._flashMessagesService.show(this.customeLineItemError, { cssClass: 'alert-warning', timeout: 5000 });
      return;
    }
    else {
      this.customeLineItemError = "";
    }
  }
  filterType(item) {
    this.page = 1;
    this.searchText = item;
    this.getCustomeLineItems();
  }

  showShippingInfoDialog(): void {
    const dialogRef = this.dialog.open(ShippingInfoComponent, {
      disableClose: true,
      data: {
        invoiceId: this.id,
        shipmentKey: this.projects.shipping_method_key,
        store_id: this.storeId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.getOrderList();
      }
    });

  }

  showAssignStaffDialog(): void {
    const dialogRef = this.dialog.open(AssignStaffComponent, {
      disableClose: true,
      data: {
        projects: this.projects
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.status == true) {
        this.getOrderList();
      }
    });
  }

  showShipmentTrackingDialog(shipment): void {
    const dialogRef = this.dialog.open(ShippingInfoComponent, {
      width: "600px",
      disableClose: true,
      data: {
        shipmentData: shipment,
        store_id: this.storeId
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  showAddress() {
    this.isShowAddress = this.isShowAddress == false ? true : false;
  }

  viewClient = function (clientID) {
    if (clientID && this.userDetails.type == 'Shop') {
      this.router.navigate(["/clients/listing/" + clientID]);
    }
  }

  convertObjectToArray(objList) {
    let addOnInput = Object.keys(objList).map(key => ({ addonid: key, addoncolor: objList[key] }));
    let objectArrayList = [];
    for (let prop in addOnInput) {
      objectArrayList.push(addOnInput[prop]['addoncolor']);
    }
    return objectArrayList;
  }

  openUpdateAddressDialog(addressType, clientId): void {
    const dialogRef = this.dialog.open(UpdateInvoiceAddressComponent, {
      width: "400px",
      disableClose: true,
      data: {
        invoiceId: this.id,
        clientId: clientId,
        addressType: addressType
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.getOrderList();
      }
    });


  }

  getCustomeLineItems = function () {
    this.customeItemOptions = {
      id: localStorage.getItem("userID"),
      limit: this.limit,
      page: this.page
    };

    if (this.searchText) {
      this.customeItemOptions.search = this.searchText;
    }

    if (this.sortDirection) {
      this.customeItemOptions.orderBy = this.sortColumnName;
      this.customeItemOptions.direction = this.sortDirection;
    }

    this.CommonService.apiService(
      "POST",
      "custom/line/items",
      this.customeItemOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.filteredOptions = response.data.records;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getSelectedValue(itemdetail, datarecord, quantity) {
    let getFilterData = this.filteredOptions.find(x => x.item === datarecord);
    itemdetail.price = getFilterData.price;
    itemdetail.description = getFilterData.description;
    if (itemdetail.price > 0 && quantity > 0) {
      this.costValidate(itemdetail.price, quantity);
    }
  }

  saveQuoteData = function (silentSave = false) {
    if (this.projects.turn_around_time == "") {
      this._flashMessagesService.show("The turn around time field is required ", {
        cssClass: "alert-warning",
        timeout: 5000
      });
      return
    }
    if (this.projects.shipping_method == "") {
      this._flashMessagesService.show("The shipping method field is required ", {
        cssClass: "alert-warning",
        timeout: 5000
      });
      return
    }

    // Initialize orderId with the project's order_id
    let orderId = (this.orderType === 'Invoice' || this.projects.type === 'Invoice') ? this.projects.order_id : this.projects.order_id || localStorage.getItem('backgroundOrderId') || '';

    //Add totalPriceCalculation key for price ovreride option.
    if (this.projects.totalPriceCalculation) {
      this.projects.projects_data = this.projects.projects_data.map(project => ({
        ...project,
        totalPriceCalculation: true
      }));
    }
    var clientId = this.projects.user_id ? this.projects.user_id : '';
    if (localStorage.getItem('CLIEINT_TYPE') === 'Guest') {
      clientId = '';
      localStorage.removeItem('CLIEINT_TYPE');
    }
    this.scheduledDate = this.CommonProjectDataService.getScheduledDate();

    // Update the `projectTitle` for each project in `projects_data`
    this.projects.projects_data.forEach((project, index) =>
      project.projectTitle = sessionStorage.getItem(`projectTitle_${index}`) || project.projectTitle
    );

    this.quoteData = {
      'id': localStorage.getItem("userID"),
      //'user_id':  this.projects.user_id ? this.projects.user_id : '',
      'user_id': clientId,
      'order_id': this.type == "Duplicate" ? this.duplicateQuoteId : orderId,
      'projects_data': this.projects.projects_data,
      'total_projects': this.projects.total_projects,
      'total_quantity': this.projects.total_quantity,
      'total_weight': this.projects.total_weight,
      'total_products_price': this.projects.total_products_price,
      'total_printing_price': this.projects.total_printing_price,
      'total_price': this.projects.total_price,
      'total_custom_items_price': this.projects.total_custom_items_price,
      'turn_around_time_price': this.projects.turn_around_time_price,
      'shipping_price': this.projects.shipping_price,
      'discount': this.projects.discount,
      'discount_percentage': this.projects.discount_percentage,
      'tax': this.projects.tax,
      'tax_percentage': this.projects.tax_percentage,
      'grand_total_price': this.projects.grand_total_price,
      'delivery_days': this.projects.delivery_days,
      'shipping_method': this.projects.shipping_method_key ? this.projects.shipping_method_key : "local_pickup",
      'turn_around_time': this.projects.turn_around_time_key ? this.projects.turn_around_time_key : 0,
      'shipping_zip': this.projects.shipping_zip ? this.projects.shipping_zip : '',
      'address_id': this.projects.address_id ? this.projects.address_id : '',
      'guest_email': this.projects.guest_email ? this.projects.guest_email : '',
      'one_time_discount_type': this.projects.one_time_discount_type ? this.projects.one_time_discount_type : '',
      'one_time_discount': this.projects.one_time_discount ? this.projects.one_time_discount : 0,
      'one_time_discounted_amt': this.projects.one_time_discounted_amt ? this.projects.one_time_discounted_amt : 0,
      'term_notes': this.projects.term_notes ? this.projects.term_notes : '',
      'order_title': this.projects.order_title ? this.projects.order_title : '',
      'trigger_email': this.triggerEmail,
      'scheduled_date': this.scheduledDate
    };
    this.loading = true;
    if (this.storeId) {
      this.quoteData.store_id = this.storeId;
    }
    this.CommonService.apiService(
      "POST",
      "order/save",
      this.quoteData
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (!silentSave) {
            this.triggerEmail = false;
            this.CommonService.removeProjectTitleStorage();
            this.quotesaved = 'yes';
            this.projects.shipping_zip = "";
            this.quoteGuestMail = "";
            this.isRebindPriceOverview = true;
            if (this.type == "Duplicate") {
              this.duplicateQuoteId = response.data.order_id;
              this.router.navigate(['/quote', { id: this.duplicateQuoteId }]);

            }
            this.orderId = response.data.order_id;
            this.projects.order_id = response.data.order_id;
            this.projects.token = response.data.token;
            if (this.type != "Duplicate") {
              this.getOrderList();
            }

            localStorage.removeItem("isorder");
            if (this.storeId && this.orderType != 'Invoice' && this.paidInvoice != "Payment") {
              this.openStorePriceDialog(this.storeId);
            }
            if (this.isTriggeredinvoiceCheckbox) {
              this.isTriggeredinvoiceCheckbox = false;
              this.refreshComponent();
            }
            if (this.paidInvoice == "Payment") {
              this.openCheckOutDialog();
              // this._flashMessagesService.show(response.message, {
              //   cssClass: "alert-success",
              //   timeout: 2000
              // });
            }
            else {
              this._flashMessagesService.show(response.message, {
                cssClass: "alert-success",
                timeout: 2000
              });
            }
          }

          if (this.isConnectQBO) {
            this.syncInvoice(response.data.order_id);
          }
        }
        window.scrollTo(0, 0);
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
      }
    );
  };

  goToLink(switchValue) {
    switch (switchValue) {
      case "saveQuote":
      case "Payment":
        this.projects.guest_email = '';
        this.paidInvoice = switchValue;
        if (this.projects.type == 'Invoice' && this.projects.isInvoiceEditable === 0) {
          this.openCheckOutDialog();
        } else {
          this.showSaveQuote();
        }
        break;
      case "AssignToStore":
        this.showAssignToStore();
        break;
      case "EmailQuote":
        this.openPublicUrlEmailDialog();
        break;
      case "PublicUrl":
        this.ViewPublicUrl('PublicUrl');
        break;
      case "CreateTask":
        this.openCreateTaskDialog();
        break;
      case "PaymentForBuilder":
        this.priceOverride();
        this.saveQuoteData();
        this.showMakePaymentForBuilder();
        break;
      case "editOrderTitle":
        this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
        break;
      case "SmsQuote":
        this.openPublicUrlSmsDialog();
        break;
      case "validateProjectData":
        this.validateProjectData();
        break;
      case "showShippingInfoDialog":
        this.showShippingInfoDialog();
        break;
      case "showShipmentTrackingDialog":
        this.showShipmentTrackingDialog(this.projects.shipments);
        break;
      case "PrintInvoice":
        this.printInvoice('PrintInvoice');
        break;
      case "printPackingSlip":
        this.printPackingSlip();
        break;
      case "BoxLabel":
        this.printInvoice('BoxLabel');
        break;
      case "StoreBoxLabel":
        this.printStoreBoxLabel();
        break;
      case "StoreCustomerOrders":
        this.printStoreCustomerOrders();
        break;
      case "ViewPublicUrl":
        this.ViewPublicUrl('');
        break;
      case "showAddress":
        this.showAddress();
        break;
      case "openDeleteDialog":
        this.openDeleteDialog(this.projects.order_id);
        break;
      case "openPaymentRefundDialog":
        this.openPaymentRefundDialog(this.projects.order_id, this.projects.paid_amount, this.projects.refunded_amount);
        break;
      case "WorkOrder":
        this.printInvoice('WorkOrder');
        break;
      default:
        // Handle default case if needed
        break;
    }
  }

  addNewProject() {
    this.activeProjectIndex = this.projects.projects_data.length;
    this.CommonProjectDataService.storeActiveProjectIndex(this.activeProjectIndex);
    let sectionData = {
      'section_items': [
        {
          'lable': "Section Title Click to Edit",
          'custom_items': [
            {
              item: "",
              price: "0",
              quantity: "0",
              description: ""
            }

          ]
        }
      ],
      'message_count': 0,
      'totalProjectQuantity': 0,
      'total_printing_price': 0
    }
    this.CommonProjectDataService.storeProductColor({});
    this.projects.projects_data.push(sectionData);
    this.CommonProjectDataService.store(this.projects);
  }

  deleteProject(pkey) {
    this.projects.projects_data.splice(pkey, 1);
    this.activeProjectIndex = 0;
    this.CommonProjectDataService.storeActiveProjectIndex(this.activeProjectIndex);
    this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
    this.getPrice();

    let orderStatus = this.CommonProjectDataService.getOrderType();
    if (orderStatus == 'Quote')
      return this.router.navigate(['/quote/order']);
    else
      return this.router.navigate(['/invoices/order']);
  }

  checkProductQty(colorID, sizeID, otherOpt) {
    var is_disable = false;
    if (otherOpt === undefined || otherOpt.quantity === undefined || otherOpt.quantity == 0) {
      is_disable = true;
    }
    return is_disable;
  }

  validateProductQty(enteredQty, allowedQty, isLessOrderLimit, pikey, pmkey, pOptions, pColorId, pSizeId, pIndex, pkey) {
    this.projects.projects_data[pkey].products[pikey].matrix[pmkey].price[pIndex] = (pOptions[pColorId][pSizeId].price) ? pOptions[pColorId][pSizeId].price : 0;
    if (isLessOrderLimit == 1 && enteredQty > 0) {
      this.isValidData = true;
      this.CommonProjectDataService.storeQuantityValidated(true);
    }
    else {
      if (enteredQty >= allowedQty || !enteredQty) {
        this.isValidData = false;
        this.CommonProjectDataService.storeQuantityValidated(false);
      }
    }
    this.manageTotalQty();
  }

  manageTotalQty() {
    var tmp_total_qty = 0;
    var tmp_total_price = 0;
    var product_total_quantity = 0;
    this.isValidData = true;
    this.CommonProjectDataService.storeQuantityValidated(true);
    this.projects.projects_data.forEach((pvalue, pkey) => {
      this.totalProjectQuantity[pkey] = 0;
      pvalue.products.forEach((mvalue, mkey) => {
        this.isLessOrderLimit = this.projects.projects_data[pkey]['products'][mkey].productDetail.less_order_limit;
        var tmp_total_qty = 0;
        mvalue.matrix.forEach((svalue, skey) => {
          tmp_total_qty = tmp_total_qty + this.totalQuantity(svalue.quantity);
          product_total_quantity = product_total_quantity + this.totalQuantity(svalue.quantity);
          this.totalProjectQuantity[pkey] = this.totalProjectQuantity[pkey] + this.totalQuantity(svalue.quantity);
          if (this.totalQuantity(svalue.quantity)) {
            this.projects.projects_data[pkey]['products'][mkey].matrix[skey].total_color_quantity = this.totalQuantity(svalue.quantity);
            this.projects.projects_data[pkey]['products'][mkey].product_total_quantity = tmp_total_qty;
          }
        });

        if (this.isLessOrderLimit == 1 && this.isQuantityValidated) {
          if (tmp_total_qty <= 0) {
            this.isValidData = false;
            this.CommonProjectDataService.storeQuantityValidated(false);
          }
        }
        if (this.isLessOrderLimit == 0) {
          if (this.totalProjectQuantity[pkey] < this.min_order_qty) {
            this.isValidData = false;
            this.CommonProjectDataService.storeQuantityValidated(false);
          }
          else {
            this.isValidData = true;
            this.CommonProjectDataService.storeQuantityValidated(true);
          }
        }
      });
      this.projects.projects_data[pkey].totalProjectQuantity = this.totalProjectQuantity[pkey];
    });
    this.total_item_price = tmp_total_price;
    this.total_item_qty = product_total_quantity;

    this.CommonProjectDataService.store(this.projects);
    this.CommonProjectDataService.storeTotalProjectQuantity(this.totalProjectQuantity);
    this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
    if (product_total_quantity > 0) {
      this.getPrice();
    }
  }
  showSectionEdit(isSectionEdit) {
    this.isSectionEdit = this.isSectionEdit == false ? true : false;
  }

  validateSectionTitle(customeSectionLable, pKey, skey) {
    this.showSectionEdit(this.isSectionEdit);
    if (!customeSectionLable) {
      this.projects.projects_data[pKey].section_items[skey].lable = "Section Title Click to Edit";
    }
    this.isSectionEdit = false;
  }

  showProductDetail(productId, selectedProductColor): void {
    let productPrices = (this.CommonProjectDataService.getSelectedProductPrice());
    let price = productPrices[productId];
    const dialogRef = this.dialog.open(ProductDetailComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        productId: productId,
        price: price,
        pageType: "Quantity",
        selectedProductColor: selectedProductColor
      }
    });
  }

  getInkType = function () {
    let Options = {
      id: localStorage.getItem("userID")
    };

    this.CommonService.apiService(
      "POST",
      "ink_types",
      Options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.inkTypeLists = response.data.records;
            this.CommonProjectDataService.storeInkTypeRequest(this.inkTypeLists);
            this.isinkdetail = 1;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getFinishingData = function () {
    this.finishingCount = 0;
    this.loading = true;
    this.Options = {
      id: localStorage.getItem("userID")
    };

    this.CommonService.apiService(
      "POST",
      "finishing_types",
      this.Options
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            this.finishingCount = response.data.records.length;
            this.CommonProjectDataService.storeFinishingCount(this.finishingCount);
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  showSaveQuote(): void {
    let username = '';
    if (this.viewClientId) {
      username = this.viewClientId;
    }
    else {
      username = this.projects.user_full_name ? this.projects.user_full_name : ''
    }

    const dialogRef = this.dialog.open(SaveQuoteComponent, {
      width: "50%",
      maxWidth: "none",
      disableClose: true,
      data: {
        user_name: username,
        paidInvoice: this.paidInvoice
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log("fgdg")
      if (result) {
        if (result.user_id) {
          localStorage.setItem("quote_user_id", result.user_id);
          this.triggerEmail = this.projects.user_id != result.user_id ? true : false;
          this.projects.user_id = result.user_id;
          this.getPrice();
          this.is_payment_term = result.is_payment_term;
        }
        this.validateProjectData();

        // else {
        //   this.validateProjectData();
        // }
      }
    });

  }

  showAssignToStore(): void {
    let storeName = '';

    const dialogRef = this.dialog.open(AssignToStoreComponent, {
      width: "50%",
      maxWidth: "none",
      disableClose: true,
      data: {
        store_name: storeName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.store_id) {
          this.storeId = result.store_id;
          this.validateProjectDataForStore();
        }
      }
    });

  }

  // Validate Project Data For Store
  validateProjectDataForStore() {
    let projectNameErr = '';
    let errorMsgErr = '';

    for (let i = 0; i < this.projects.projects_data.length; i++) {
      projectNameErr = (this.projects.projects_data[i].projectTitle) ? (this.projects.projects_data[i].projectTitle) : 'Project ' + (i+1);
      if (this.projects.projects_data[i].products && this.projects.projects_data[i].products.length > 0) {
        if (this.storeId) {
          if (this.projects.projects_data[i].products.length > 1) {
            errorMsgErr = projectNameErr + " : Please select only one product in store Quote";
            break;
          }
          else {
            if (this.projects.projects_data[i].products[0].matrix.length > 1) {
              errorMsgErr = projectNameErr + " : Please select only one color for product in store Quote";
              break;
            }
          }
        }
      }
    }

    if (errorMsgErr) {
      this.storeId = "";
      this._flashMessagesService.show(errorMsgErr, {
        cssClass: "alert-danger",
        timeout: 5000
      });
    } else {
      this.validateProjectData();
    }
  }

  getUserAddressData = function (selectedUserId) {
    let option = {
      id: selectedUserId
    };

    this.CommonService.apiService(
      "POST",
      "user/addresses",
      option
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.address = response.data;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  showPaymentProcess() {
    if (this.orderType != 'Invoice') {
      this.isShowCheckout = false;
      this.paidInvoice = 'Payment';
      this.showSaveQuote();
    }
    else {
      this.isShowCheckout = true;
      this.getPrice();
    }
  }

  activeProject(activeProjectIndex) {
    this.activeProjectIndex = activeProjectIndex;
    this.CommonProjectDataService.storeActiveProjectIndex(this.activeProjectIndex);
    if (this.projects.projects_data[this.activeProjectIndex].selectedProductColors) {
      this.CommonProjectDataService.storeProductColor(this.projects.projects_data[this.activeProjectIndex].selectedProductColors);
    }
  }

  // Check Project Data functinality
  validateProjectData() {
    this.errorMsg = '';
    let isvalidateData = false;
    let projectName = '';
    for (let i = 0; i < this.projects.projects_data.length; i++) {
      this.activeProjectIndex = i;
      projectName = (this.projects.projects_data[i].projectTitle) ? (this.projects.projects_data[i].projectTitle) : 'Project' + (i+1);
      isvalidateData = this.checkProductInk();
      let isProductExist = JSON.parse(JSON.stringify(isvalidateData));
      if (isvalidateData) {
        isvalidateData = this.checkOrderQuantity();
        if (isvalidateData) {
          isvalidateData = this.checkPrintSpec();
        }
      }
      isvalidateData = this.validateSectionData(isProductExist);
      if (!isvalidateData && this.errorMsg) {
        this._flashMessagesService.show(projectName + ' : ' + this.errorMsg, {
          cssClass: "alert-danger",
          timeout: 5000
        });
        return isvalidateData;
      }
    }
    if (this.errorMsg) {
      this._flashMessagesService.show(projectName + ' : ' + this.errorMsg, {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
    else {
      this.saveQuoteData();
    }

    return isvalidateData
  }

  checkProductInk() {
    if (this.projects.projects_data[this.activeProjectIndex].products && this.projects.projects_data[this.activeProjectIndex].products.length > 0) {
      if (this.storeId) {
        if (this.projects.projects_data[this.activeProjectIndex].products.length > 1) {
          this.errorMsg = "Please select only one product in store Quote";
          return false;
        }
        else {
          if (this.projects.projects_data[this.activeProjectIndex].products[0].matrix.length > 1) {
            this.errorMsg = "Please select only one color for product in store Quote";
            return false;
          }
        }
      }
      let totalProjectQuantity = this.projects.projects_data[this.activeProjectIndex].totalProjectQuantity;

      if (!this.storeId) {
        if (totalProjectQuantity <= 0) {
          this.errorMsg = "Please enter product quantity";
          return false;
        }
        else {
          return true
        }
      }
      else {
        return true;
      }
    }
    else {
      return false;
    }
  }

  checkOrderQuantity() {
    let isQuantityValidated = true;
    this.min_order_qty = this.CommonProjectDataService.getMinOrderQty();
    let totalProjectQuantity = this.projects.projects_data[this.activeProjectIndex].totalProjectQuantity;
    let x = 0;
    if (totalProjectQuantity > 0) {
      this.projects.projects_data[this.activeProjectIndex].products.forEach((mvalue, mkey) => {

        if (isQuantityValidated) {
          let isLessOrderLimit = this.projects.projects_data[this.activeProjectIndex]['products'][mkey].productDetail.less_order_limit;
          var tmp_total_qty = 0;
          let enteredquantity = 0;
          let productDetail = this.projects.projects_data[this.activeProjectIndex]['products'][mkey].productDetail;
          mvalue.matrix.forEach((svalue, skey) => {
            if (isQuantityValidated) {
              svalue.size.forEach((psize, qkey) => {
                if (isQuantityValidated) {
                  if (productDetail.title != 'own-garment') {
                    let sizeStock = productDetail.options[svalue.color.color_id][psize.size_id] ? productDetail.options[svalue.color.color_id][psize.size_id]['quantity'] : 0;
                    enteredquantity = svalue.quantity[qkey] ? svalue.quantity[qkey] : 0;
                    if (productDetail.type != 'custom') {
                      isQuantityValidated = true;
                    }
                    else {
                      if (productDetail.type == 'custom' && (sizeStock == '' || sizeStock == 0 || sizeStock == null) && enteredquantity >= 0) {
                        isQuantityValidated = true;
                      }
                      else {
                        if (enteredquantity > 0 && enteredquantity > sizeStock) {
                          this.errorMsg = "Please enter valid Quantity";
                          isQuantityValidated = false;
                        }
                        else {
                          isQuantityValidated = true;
                        }
                      }
                    }
                  }
                  else {
                    if (enteredquantity > 0) {
                      this.errorMsg = "Please enter valid Quantity";
                      isQuantityValidated = false;
                    }
                    else {
                      isQuantityValidated = true;
                    }
                  }
                }
              }
              )
            }
          });

          if (isLessOrderLimit == 1 && isQuantityValidated) {
            if (totalProjectQuantity <= 0) {
              this.errorMsg = "Please enter Quantity";
              isQuantityValidated = false;
              return isQuantityValidated;
            }
          }
          if (isLessOrderLimit == 0 && isQuantityValidated) {
            if ((totalProjectQuantity < this.min_order_qty) && !this.projects.store_id) {
              this.errorMsg = "Total Quantity must be greater than " + this.min_order_qty;
              isQuantityValidated = false;
              return isQuantityValidated;
            }
            else {
              isQuantityValidated = true;
            }
          }
        }
      });
      if (isQuantityValidated) {
        this.handleQuantity(isQuantityValidated);
      }
    }
    else {
      isQuantityValidated = true;
      if (!this.storeId) {
        if (this.projects.projects_data[this.activeProjectIndex].products && this.projects.projects_data[this.activeProjectIndex].selectedProductColors) {
          delete this.projects.projects_data[this.activeProjectIndex].products;
          delete this.projects.projects_data[this.activeProjectIndex].selectedProductColors;
        }
      }
    }
    return isQuantityValidated;
  }

  checkPrintSpec() {
    let isPrintSpec = true;
    let activeLocationArr = this.projects.projects_data[this.activeProjectIndex].active_location_arr;
    let projectData = this.projects.projects_data[this.activeProjectIndex];
    if (activeLocationArr && activeLocationArr.length > 0) {

      activeLocationArr.forEach((plkey) => {
        if (isPrintSpec) {
          if ((projectData.printPositionSetting && projectData.printPositionSetting[plkey.emblocation_id])
            && (projectData.printPositionSetting[plkey.emblocation_id].printWidth != ''
              && projectData.printPositionSetting[plkey.emblocation_id].printPosition.name != '')

          ) {
            if (projectData.printPositionSetting[plkey.emblocation_id].printType != 'per_color') {
              if (projectData.printPositionSetting[plkey.emblocation_id].printHeight != '') {
                isPrintSpec = true;
              }
              else {
                this.errorMsg = "Please Select print measurements detail";
                isPrintSpec = false;
              }

            }
            else {
              isPrintSpec = true;
            }
            if (projectData.printPositionSetting[plkey.emblocation_id].printType != 'per_item') {
              // if (projectData.printPositionSetting[plkey.emblocation_id].printDistance != '') {
              //   isPrintSpec = true;
              // }
              // else {
              //   this.errorMsg = "Please Select print measurements detail";
              //   isPrintSpec = false;
              // }
              isPrintSpec = true;
            }
            else {
              isPrintSpec = true;
            }
          }
          else {
            this.errorMsg = "Please Select print measurements detail";
            isPrintSpec = false;
          }
        }
        if (isPrintSpec) {
          if (((projectData.inkColorObj && projectData.inkColorObj[plkey.emblocation_id] && projectData.inkColorObj[plkey.emblocation_id].length > 0)
            || (projectData.printAddonInputSettingObj && projectData.printAddonInputSettingObj[plkey.emblocation_id]
              && Object.keys(projectData.printAddonInputSettingObj[plkey.emblocation_id]).length > 0))) {
            isPrintSpec = true;
          }
          else {
            this.errorMsg = "Please select print spec ink color";
            isPrintSpec = false;
          }
        }
      }
      )
      if (isPrintSpec) {
        this.checkInkType();
      }
    }
    return isPrintSpec;
  }

  checkInkType() {
    if (this.projects.projects_data[this.activeProjectIndex]['ink_Details'] && this.projects.projects_data[this.activeProjectIndex]['ink_Details'].ink_type_id && this.projects.projects_data[this.activeProjectIndex]['ink_Details'].ink_name) {
      return true;
    }
    else {
      this.errorMsg = "Please Select Ink type";
      return false;
    }

  }

  handleQuantity(isQuantityValidated) {
    //default select color when color is not selected
    if (isQuantityValidated && this.projects.projects_data[this.activeProjectIndex] && this.projects.projects_data[this.activeProjectIndex].products.length > 0) {
      //remove products having 0 quantity
      let tempProject = JSON.parse(JSON.stringify(this.projects));
      if (!this.storeId) {
        tempProject.projects_data.forEach((pvalue, pkey) => {
          if (pvalue.products) {
            pvalue.products.forEach((mvalue, mkey) => {
              mvalue.matrix.forEach((svalue, skey) => {
                if (this.totalQuantity(svalue.quantity) == 0) {
                  let product_id = tempProject.projects_data[pkey]['products'][mkey].product_id;
                  let color_id = tempProject.projects_data[pkey]['products'][mkey].matrix[skey].color.color_id;
                  let color_index = tempProject.projects_data[pkey].selectedProductColors[pkey][product_id].indexOf(color_id)
                  tempProject.projects_data[pkey].selectedProductColors[pkey][product_id].splice(color_index, 1);
                  delete tempProject.projects_data[pkey]['products'][mkey].matrix[skey];
                }
              })
              mvalue.matrix = mvalue.matrix.filter(function (el) {
                return el != null;
              });

              if (mvalue.matrix.length == 0) {
                tempProject.projects_data[pkey]['products'].splice(mkey, 1);
              }
            })
          }
        })
      }
      this.projects = tempProject;
      this.CommonProjectDataService.store(this.projects);
    }
  }

  validateSectionData(isProductExist) {
    let isSectionItemValidate = false;
    let sectionItems = this.projects.projects_data[this.activeProjectIndex].section_items;
    if (sectionItems.length == 1 && sectionItems[0].custom_items.length == 1 && this.projects.projects_data.length >= 1) {
      let customeItem = sectionItems[0].custom_items[0];
      if (customeItem.item == '' && customeItem.price == 0 && customeItem.quantity == 0 && isProductExist) {
        this.projects.projects_data[this.activeProjectIndex].section_items.splice(0);
        isSectionItemValidate = true;
      }
      isSectionItemValidate = true;

    }
    else {
      sectionItems.forEach((svalue, skey) => {
        svalue.custom_items.forEach((cvalue, ckey) => {
          if (cvalue.item == '' && cvalue.price == 0 && cvalue.quantity == 0) {
            isSectionItemValidate = false;
            this.errorMsg = "Custom Line item can not be blank and price and quantity must be greater than 0";
          }
          else {
            isSectionItemValidate = true;
          }
        })
      })
    }

    return isSectionItemValidate;
  }

  openGuestEmailDialog(): void {
    const dialogRef = this.dialog.open(GuestEmailComponent, {
      width: "500px",
      data: {
        user_id: '',
        manageData: { guest_email: '' }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.guest_email) {
        this.projects.guest_email = result.guest_email;
        this.validateProjectData();
      }
    });
  }

  openPublicUrlEmailDialog(): void {
    const dialogRef = this.dialog.open(MailPublicUrlComponent, {
      width: "500px",
      data: {
        order_id: this.projects.order_id,
        client_mail: this.projects.user_email
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  ViewPublicUrl(requestFrom) {
    let viewUrl = ''
    let routerURL = this.isPublicQuoteCreation == true ? '/builder/invoice/' : '/invoice/'; // When the isPublicQuoteCreation == true, then assign the builder route for customer portal
    if (requestFrom == 'PublicUrl') {
      viewUrl = window.location.origin + routerURL + this.publicToken;
    }
    else {
      viewUrl = window.location.origin + routerURL + this.publicToken;
    }

    window.open(viewUrl, "_blank");
  }

  showConfirmMessage() {
    if (this.quotesaved == 'yes') {
      localStorage.removeItem("isorder");
      this.quotesaved = '';
    }
    else {
      localStorage.setItem('prevPrice', JSON.stringify(this.prevPrice));
      if (this.grandTotalPrice > 0 && this.prevPrice != this.grandTotalPrice) {
        localStorage.setItem("isorder", 'yes');
      }
      else {
        localStorage.removeItem("isorder");
      }
    }
  }

  convertToNumber(value) {
    return Number(value);
  }

  changeDiscount(type) {
    this.errorClass = false;
    if (type == 'discountType') {
      if (this.projects.one_time_discount) {
        this.projects.one_time_discount = 0;
        this.getPrice();
      }
    }
    else {
      if (this.projects.one_time_discount == null) {
        this.projects.one_time_discount = 0;
      }
      if (this.projects.one_time_discount_type == "Percentage" && this.projects.one_time_discount > 100) {
        this.errorClass = true;
        this._flashMessagesService.show("The one time discount percentage may not be greater than 100", {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
      else {
        this.getPrice();
      }
    }
  }

  getOneTimeDiscount = function () {
    this.oneTimeDiscount = 0;
    if ((this.projects.one_time_discount_type && this.projects.one_time_discount_type != '') && (this.projects.one_time_discount && this.projects.one_time_discount != '')) {

      let TotalPrice = Number(this.projects.total_price) + Number(this.projects.total_custom_items_price) + Number(this.projects.turn_around_time_price) + Number(this.projects.shipping_price);
      if (this.projects.one_time_discount_type == "Percentage") {
        this.oneTimeDiscount = this.numRoundToPlace((TotalPrice * this.projects.one_time_discount) / 100, 2);
      }
      if (this.projects.one_time_discount_type == "Doller Amount") {
        this.oneTimeDiscount = this.projects.one_time_discount;
      }
      this.projects.grand_total_price = this.numRoundToPlace(this.projects.grand_total_price - this.oneTimeDiscount, 2);
    }
  }

  numRoundToPlace(num, dec) {
    if ((typeof num !== 'number') || (typeof dec !== 'number'))
      return false;
    var num_sign = num >= 0 ? 1 : -1;
    return (Math.round((num * Math.pow(10, dec)) + (num_sign * 0.0001)) / Math.pow(10, dec)).toFixed(dec);
  }

  openPaymentRefundDialog(invoiceId, payAmount, refundedAmount): void {
    const dialogRef = this.dialog.open(PaymentRefundComponent, {
      width: "900px",
      disableClose: true,
      data: {
        user_id: localStorage.getItem("userID"),
        invoice_id: invoiceId,
        pay_Amount: payAmount,
        refunded_Amount: refundedAmount,
        transactions: this.projects.transactions
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.router.navigateByUrl('/RefrshComponent', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/invoices/" + invoiceId]));
      }
    });
  }

  openCreateTaskDialog(): void {
    const dialogRef = this.dialog.open(AddTaskComponent, {
      width: "400px",
      disableClose: true,
      data: {
        orderId: this.id,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.getTaskDetail();
      }
    });
  }

  getTaskDetail = function () {
    this.loading = true;
    this.Options = {
      id: this.shopId,
      invoice_id: this.id,
      is_staff_group: 'y',
      page: 1,
      limit: 100,
      orderBy: 'staff_first_name',
      direction: 'asc'
    };

    this.CommonService.apiService(
      "POST",
      "tasks",
      this.Options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          if (response.data) {
            this.taskList = response.data.records;
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }


  updateTaskStatus = function (taskId, status) {
    this.taskOption = {
      id: localStorage.getItem("userID"),
      task_id: taskId,
      is_visible_to_client: status
    }

    this.CommonService.apiService(
      "POST",
      "task/status",
      this.taskOption
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show("Task status updated successfully!", {
            cssClass: "alert-success",
            timeout: 5000
          });
          this.getTaskDetail();
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  }

  removeString(transId, type) {
    let chequNo = type == 'Cheque' ? '(Check No: ' + transId.replace('Cheque_', '') + ')' : '';
    return chequNo;
  }

  openDeleteDialog(id: number): void {
    let paidAmount = this.projects.paid_amount ? this.projects.paid_amount : 0;
    let refundedAmount = this.projects.refunded_amount ? this.projects.refunded_amount : 0;
    let refundBalance = paidAmount - refundedAmount;
    if (refundBalance == 0) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: "250px",
        data: {
          name: "Admin",
          message: "Are you sure you want to delete this invoice",
          manageData: { order_id: id }
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result && result.order_id) {
          this.deleteQuote(result.order_id);
        }
      });
    }
    else {
      this._flashMessagesService.show("Please Refund all paid amount,then delete invoice", {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
  }

  deleteQuote = function (invoice_id) {
    this.clientOptions = {};
    this.CommonService.apiService(
      "DELETE",
      "order/" + localStorage.getItem("userID") + "/" + invoice_id,
      this.clientOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.router.navigate(['/invoices']);
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  };

  calculatePricePerPiece(priceMarkupData, productId, colorId, sizeId, totalPrintingPrice, totalQty, qtyPerSize) {
    let totalPricePerPiece = 0;
    if (priceMarkupData != '' && qtyPerSize > 0) {
      let priceMarkup = (priceMarkupData[productId] && priceMarkupData[productId][colorId] && priceMarkupData[productId][colorId][sizeId] && priceMarkupData[productId][colorId][sizeId].priceMarkup) ? priceMarkupData[productId][colorId][sizeId].priceMarkup : 0;
      let perPiecePrintPrice = totalPrintingPrice > 0 ? totalPrintingPrice / totalQty : 0;
      let perPiecePriceMarkup = priceMarkup > 0 ? priceMarkup / qtyPerSize : priceMarkup;
      let totalPricePerPiece = this.numRoundToPlace((perPiecePriceMarkup), 2);
      return totalPricePerPiece;
    }
    else {
      return totalPricePerPiece;
    }
  }
  calculatePricePerPieceTotal(priceMarkupData, productId, colorId, sizeId, totalPrintingPrice, totalQty, qtyPerSize) {
    let totalPricePerPiece = 0;
    if (priceMarkupData != '' && qtyPerSize > 0) {
      let priceMarkup = (priceMarkupData[productId] && priceMarkupData[productId][colorId] && priceMarkupData[productId][colorId][sizeId] && priceMarkupData[productId][colorId][sizeId].priceMarkup) ? priceMarkupData[productId][colorId][sizeId].priceMarkup : 0;
      let perPiecePrintPrice = totalPrintingPrice > 0 ? totalPrintingPrice / totalQty : 0;
      let perPiecePriceMarkup = priceMarkup > 0 ? priceMarkup / qtyPerSize : priceMarkup;
      let totalPricePerPiece = this.numRoundToPlace((perPiecePriceMarkup + perPiecePrintPrice), 2);
      return totalPricePerPiece;
    }
    else {
      return totalPricePerPiece;
    }
  }

  calculateInventory(enteredQty, inStockQty, sizeIndex, colorId, productId) {
    let totalBalance = 0;
    let isproducExist = false;
    if (this.projects.projects_data.length > 1) {
      for (let i = 0; i < this.projects.projects_data.length; i++) {
        let products = (this.projects.projects_data[i].products) ? this.projects.projects_data[i].products.find(x => x.product_id === productId) : '';
        if (products) {
          for (let m = 0; m < products.matrix.length; m++) {
            if (products.matrix[m].color.color_id == colorId) {
              isproducExist = true;
              totalBalance += products.matrix[m].quantity[sizeIndex];
            }
            else {
              isproducExist = false;
              totalBalance = 0;
            }
          }
        }
      }
    }

    if (inStockQty != '') {
      let totaEnteredQty = isproducExist == true ? totalBalance : enteredQty;
      return (inStockQty - totaEnteredQty);
    }
    else {
      return 0;
    }
  }

  showCdrFile(urlname) {
    let urlExt = urlname.split('.').pop().toLowerCase();
    if (['cdr'].indexOf(urlExt) >= 0) {
      return 'assets/img/' + urlExt + '.png';
    }
    else {
      return urlname;
    }
  }

  openStorePriceDialog(storeId): void {
    this.projects.projects_data.forEach(p => {
      p.products.forEach(prod => {
        if (!prod.product_title) {
          prod.product_title = '';
          prod.store_commission = 0;
          prod.retail_price = 0;
        }
      });
    });
    const dialogRef = this.dialog.open(StoreProductPriceComponent, {
      width: "500px",
      data: {
        projects_data: this.projects.projects_data,
        storeId: storeId,
        quoteId: this.projects.order_id,
        type: 'assign'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'success') {
        this._flashMessagesService.show("Record Saved successfully", {
          cssClass: "alert-success",
          timeout: 3000
        });
        this.router.navigate(['/stores']);
      }
    });
  }
  getProductMatrix = function (catalogue) {
    this.loading = true;
    if (catalogue == 'all') {
      this.productOptions = {
        id: this.shopId
      };
    } else {
      this.productOptions = {
        id: this.shopId,
        provider: catalogue
      };
    }
    this.CommonService.apiService(
      "POST",
      "order/get_matrix",
      this.productOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.CommonProjectDataService.storeProductMatrix(response.data);
          this.productMatrix = this.CommonProjectDataService.getProductMatrix();
        }
      },
      err => {
        console.log(err);
      }
    );
    this.loading = false;
  };

  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  updateIsCheckedProjectTab(projectIndex) {
    this.isTriggeredinvoiceCheckbox = true;
    this.checkedProjectTabLocs = [];
    this.checkedProjectTabFinishing = [];
    if (this.projects && this.projects.projects_data[projectIndex]) {
      // Checkboxes : Ink Change Out && Change Name and Number 
      if (this.projects.projects_data[projectIndex].active_location_arr) {

        this.projects.projects_data[projectIndex].active_location_arr.forEach((printLocs, printIndex) => {
          if (this.projects.projects_data[projectIndex].printPositionSetting[printLocs.emblocation_id] && (this.projects.projects_data[projectIndex].printPositionSetting[printLocs.emblocation_id].nameTotalCount && this.projects.projects_data[projectIndex].printPositionSetting[printLocs.emblocation_id].nameTotalCount > 0) || (this.projects.projects_data[projectIndex].printPositionSetting[printLocs.emblocation_id].numberTotalCount && this.projects.projects_data[projectIndex].printPositionSetting[printLocs.emblocation_id].numberTotalCount > 0)) {
            if (this.projects.projects_data[projectIndex].printPositionSetting[printLocs.emblocation_id].isCheckedChangeNameAndNo) {
              this.checkedProjectTabLocs.push(true);
            }
            else {
              this.checkedProjectTabLocs.push(false);
            }
            this.isAnyOptionOfTabCheckbox = true;
          }
          if (this.projects.projects_data[projectIndex].inkChangeData[printLocs.emblocation_id] && this.projects.projects_data[projectIndex].inkChangeData[printLocs.emblocation_id].colorChange && this.projects.projects_data[projectIndex].inkChangeData[printLocs.emblocation_id].totalColor > 0 && this.projects.projects_data[projectIndex].inkChangeData[printLocs.emblocation_id].updData && this.projects.projects_data[projectIndex].inkChangeData[printLocs.emblocation_id].updData.length > 0) {
            if (this.projects.projects_data[projectIndex].inkChangeData[printLocs.emblocation_id].isCheckedInkChangeOut) {
              this.checkedProjectTabLocs.push(true);
            }
            else {
              this.checkedProjectTabLocs.push(false);
            }
            this.isAnyOptionOfTabCheckbox = true;
          }
        });
      }
      // Checkboxes : finishing details
      if (this.projects.projects_data[projectIndex].finishingDetails && this.projects.projects_data[projectIndex].finishingDetails.length) {
        this.projects.projects_data[projectIndex].finishingDetails.forEach((finishingValue, finishingIndex) => {
          if (finishingValue.isCheckedFinishing) {
            this.checkedProjectTabFinishing.push(true);
          }
          else {
            this.checkedProjectTabFinishing.push(false);
          }
          this.isAnyOptionOfTabCheckbox = true;
        });
      }
      this.projects.projects_data[projectIndex].isCheckedProjectTab = (!this.checkedProjectTabLocs.includes(false) && !this.checkedProjectTabFinishing.includes(false) && this.isAnyOptionOfTabCheckbox) ? true : false;
      this.CommonProjectDataService.store(this.projects);
    }
  }

  updateClickPickerStatus() {
    this.isClickPickerStatus = true;
    this.updateDueDate();
  }

  updateDueDate = function () {
    if (this.isClickPickerStatus && this.dueDateForm.value.dueDate) {
      const dueDateF = new Date(this.dueDateForm.value.dueDate);
      const timeZoneOffset = dueDateF.getTimezoneOffset() * 60000;
      const isoString = new Date(dueDateF.getTime() - timeZoneOffset).toISOString();
      const updateData = {
        'id': localStorage.getItem("userID"),
        'order_id': this.projects.order_id,
        'delivery_days': this.projects.delivery_days,
        'dueDate': isoString.substring(0, 10)
      };

      this.loading = true;
      this.CommonService.apiService(
        "POST",
        "order/saveDueDate",
        updateData
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {
            this.isClickPickerStatus = false;
            this.CommonProjectDataService.storeDeliveryDate(response.data.dueDate);
            this.projects.delivery_date = response.data.dueDate;
            this.dueDateForm.controls.dueDate.setValue(new Date(response.data.dueDate));
            
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 2000
            });
          }
          window.scrollTo(0, 0);
        },
        err => {
          this.loading = false;
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      );
    }
  };

  // Update invoice editable status
  updateIsInvoiceEditable = function () {
    const updateData = {
      'id': localStorage.getItem("userID"),
      'order_id': this.projects.order_id,
      'is_editable': this.projects.isInvoiceEditable
    };

    this.CommonService.apiService(
      "POST",
      "order/saveIsInvoiceEditable",
      updateData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.getOrderList();

          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 2000
          });
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
      }
    );
  };

  // Make payment for public quote builder on the customer portal
  showMakePaymentForBuilder() {
    if (this.orderType == "Quote" && this.isPublicQuoteCreation == true) {
      this.isShowCheckout = false;
      this.openCheckOutDialogForBuilder();
    }
  }
  // Open checkout dialog for public quote builder on the customer portal
  openCheckOutDialogForBuilder() {
    const dialogRef = this.dialog.open(CheckOutComponent, {
      width: "600px",
      disableClose: true,
      data: {
        isPublicQuoteCreation: this.isPublicQuoteCreation,
        public_url_token: this.publicToken,
        is_public_url: 'Yes',
        allowPartialPayment: this.projects.allow_partial_payment_public_url,
        user_id: this.projects.user_id,
        amount: this.orderType == 'Quote' ? this.projects.grand_total_price : this.balanceAmount,
        paidAmount: this.projects.paid_amount,
        order_id: this.projects.order_id,
        manageData: { guest_email: '' },
        order_instructions_payment: this.projects.order_instructions_payment,
        order_instruction_title: this.projects.order_instruction_title,
        paypal_payment_enable: this.projects.paypal_payment_enable,
        paypal_payment_api_key: this.projects.paypal_payment_api_key,
        turnAroundTimes: this.turnAroundTimes,
        turn_around_time: this.projects.turn_around_time_key ? this.projects.turn_around_time_key : 0,
        shipping_method: this.projects.shipping_method_key ? this.projects.shipping_method_key : "local_pickup",
        shipping: this.shipping,
        is_payment_term: this.is_payment_term,
        projects: this.projects,
        shippingAddress: this.address,
        turnAroundName: this.turnAroundName,
        cc_payment_enable: this.projects.cc_payment_enable,
        cc_payment_api: this.projects.cc_payment_api,
        orderType: this.orderType,
        isShippingOption: this.isShippingOption,
        isLocalPickupOption: this.isLocalPickupOption,
        cardProcessingFees: this.cardProcessingFees,
        isConnectQBO: this.isConnectQBO,
        scheduledDate: this.scheduledDate
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        // Refresh component when payment made success
        this.router.navigateByUrl('/RefrshComponent', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/builder/invoice/" + this.publicToken]));
      }
    });
  }

  openPriceEdit(productIndex, matrixIndex, sizeIndex, openStatus, getPriceOverride = false) {
    this.hideAllEditIcon = openStatus ? true : this.hideAllEditIcon;
    if (this.projects.projects_data[this.activeProjectIndex]) {
      if (this.projects.projects_data[this.activeProjectIndex].products[productIndex]) {
        if (this.projects.projects_data[this.activeProjectIndex].products[productIndex].matrix[matrixIndex]) {
          this.projects.projects_data[this.activeProjectIndex].products[productIndex].matrix[matrixIndex].openPriceEdit = new Array(this.projects.projects_data[this.activeProjectIndex].products[productIndex].matrix[matrixIndex].size.length).fill(null);
          this.projects.projects_data[this.activeProjectIndex].products[productIndex].matrix[matrixIndex].openPriceEdit[sizeIndex] = openStatus;
          if (getPriceOverride) {
            this.projects.projects_data[this.activeProjectIndex].products[productIndex].matrix[matrixIndex].openPriceEditLoader[sizeIndex] = getPriceOverride;
          } else {
            this.projects.projects_data[this.activeProjectIndex].products[productIndex].matrix[matrixIndex].openPriceEditLoader = new Array(this.projects.projects_data[this.activeProjectIndex].products[productIndex].matrix[matrixIndex].size.length).fill(null);
          }
          this.projects.totalPriceCalculation = true;
          this.CommonProjectDataService.store(this.projects);
          
          if (getPriceOverride) {
            this.priceOverrideLocation = {
              productIndex: productIndex,
              matrixIndex: matrixIndex,
              sizeIndex: sizeIndex,
              openStatus: openStatus
            };
            this.priceOverrideLoading = true;
            this.priceOverride();
          }
        }
      }
    }
  }

  updatePriceInProductsMatrix(priceMarkupProduct, products, impressionPrice, projectIndexing) {
    for (let productId in priceMarkupProduct) {
      for (let colorId in priceMarkupProduct[productId]) {
        for (let sizeId in priceMarkupProduct[productId][colorId]) {

          let ProductIndex = products.findIndex(p => p.product_id === productId);
          let product = products.find(p => p.product_id === productId);
          if (!product) continue;

          let matrixIndex = product.matrix.findIndex(m => m.color.color_id === colorId);
          let matrixItem = product.matrix.find(m => m.color.color_id === colorId);
          if (!matrixItem) continue;

          let sizeIndex = matrixItem.size.findIndex(s => s.size_id === sizeId);
          if (sizeIndex === -1) continue;

          let quantity = priceMarkupProduct[productId][colorId][sizeId].quantity;
          let priceMarkup = priceMarkupProduct[productId][colorId][sizeId].priceMarkup;
          let itemPrice = priceMarkup > 0 ? priceMarkup / quantity : priceMarkup;
          let totalPrice = itemPrice + impressionPrice;

          this.projects.projects_data[projectIndexing].products[ProductIndex].matrix[matrixIndex].item_price[sizeIndex] = itemPrice;
          this.projects.projects_data[projectIndexing].products[ProductIndex].matrix[matrixIndex].total_price[sizeIndex] = totalPrice;
          this.projects.projects_data[projectIndexing].products[ProductIndex].matrix[matrixIndex].impression_price[sizeIndex] = impressionPrice;
        }
      }
    }
  }

  priceOverride() {
    //Add totalPriceCalculation key for price ovreride option.
    if (this.projects.totalPriceCalculation) {
      this.projects.projects_data = this.projects.projects_data.map(project => ({
        ...project,
        totalPriceCalculation: true
      }));
    }
    this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
    this.getPrice();
    // Update the value of isPriceOverrideInvoice for price override options
    this.isPriceOverrideInvoice = this.projects.type == 'Invoice' ? true : this.isPriceOverrideInvoice;
  }

  refreshComponent() {
    const currentUrl = this.router.url;
    setTimeout(() => {
      this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });
    }, 2000);
  }

  editOrderTitle() {
    this.CommonProjectDataService.store(this.projects);
  }

  HideShowCon(i, activeProjectIndex) {
    this.headerShow = (this.projects.projects_data[activeProjectIndex].hasOwnProperty("products") && this.projects.projects_data[activeProjectIndex].products.length > 0) ? true : false;
    return (i == activeProjectIndex) ? true : false;
  }

  updatePrintDesciption(printPositionSetting: any){
    this.CommonProjectDataService.store(this.projects);
  }

  getImpressionLocationCost(printPositionKey: any): number {
    const activeProject = this.projects.projects_data[this.activeProjectIndex];

    if (activeProject && activeProject.priceDistributionData) {
      const distributionData = activeProject.priceDistributionData.find(
        (d) => d.printPositionKey === printPositionKey
      );

      return distributionData ? distributionData.perProductTotalPrintingCost : 0;
    }

    return 0;
  }

  isShippingOptions = function () {
    const options = [
      'shipping_options',
      'local_pickup_options',
      'cardProcessingFees'
    ];

    this.SettingService.getSetting(options, this.shopId).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data.shipping_options === '0') {
            this.isShippingOption = false;
          }

          if (response.data.local_pickup_options === '0') {
            this.isLocalPickupOption = false;
          }

          if (response.data.cardProcessingFees) {
            this.cardProcessingFees = JSON.parse(response.data.cardProcessingFees);
          }
        }
      }
    );
  }

  printInvoice(invoiceType: string) {
    const printInvoiceData = {
      invoiceType: invoiceType,
      projectData: this.projects,
      paymentHistory: this.paymentHistory,
      refundHistory: this.refundHistory,
    };
    localStorage.setItem('printInvoiceData', JSON.stringify(printInvoiceData));

    const routePath = `/invoices/print-invoice/${this.projects.order_id}`;
    this.router.navigate([routePath]);
  }

  isAnyQuantityGreaterThanZero(pmatrix: any): boolean {
    for (let z = 0; z < pmatrix.size.length; z++) {
      if (pmatrix.quantity[z] > 0) {
        return true;
      }
    }
    return false;
  }

  getTooltipOptions() {
    this.SettingService.getTooltipOptions().subscribe(
      (response: any) => {
        if (response.status === true && response.data) {
          this.tooltipOptions = response.data;
          sessionStorage.setItem('tooltipOptions', JSON.stringify(this.tooltipOptions));
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  openPublicUrlSmsDialog(): void {
    const dialogRef = this.dialog.open(SmsPublicUrlComponent, {
      width: "500px",
      data: {
        order_id: this.projects.order_id,
        client_phone: this.projects.user_phone
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  toggleTurnCost(event: any, costItem: string, projectIndex: number, productIndex: number) {
    if (this.projects.projects_data[projectIndex].products[productIndex]) {
      const checkStatus = event.source.checked ? 'Yes' : 'No';

      switch (costItem) {
        case 'BlankItemCost':
          this.projects.projects_data[projectIndex].products[productIndex].isTurnOnBlankItemCost = checkStatus;
          this.CommonProjectDataService.store(this.projects);
          break;
        case 'ImpressionCost':
          this.projects.projects_data[projectIndex].products[productIndex].isTurnOnImpressionCost = checkStatus;
          this.CommonProjectDataService.store(this.projects);
          break;
        default:
          // Handle default case if needed
          break;
      }
    }
  }

  ShowLineItemArtworkDialog(projects, projectKey, sectionKey, customItemKey): void {
    let sectionItems = projects.projects_data[projectKey].section_items;
    this.errorMsg = '';
    sectionItems.forEach((svalue) => {
      svalue.custom_items.forEach((cvalue) => {
        if (cvalue.item == '' || cvalue.price == 0 || cvalue.quantity == 0) {
          this.errorMsg = "Any custom line items should not be blank, and their prices and quantities must be greater than 0; otherwise, they should be removed.";
        }
      })
    })
    if (this.errorMsg) {
      this._flashMessagesService.show(this.errorMsg, {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
    else {
      this.saveQuoteData(true);
      const dialogRef = this.dialog.open(InvoiceItemComponent, {
        width: "90%",
        maxWidth: "none",
        disableClose: true,
        data: {
          lineItemArtworkData: { 
            invoiceId: this.projects.order_id,
            projectStatus: this.projects.status,
            projects: projects,
            projectKey: projectKey,
            sectionKey: sectionKey,
            customItemKey: customItemKey,
          },
          userId: projects.user_id,
          orderType: this.orderType
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == "success") {
          this.getOrderList();
        }
      });
    }
  }

  ShowLineItemMockupDialog(projects, projectKey, sectionKey, customItemKey): void {
    const dialogRef = this.dialog.open(InvoiceItemComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        lineItemMockupData: { 
          invoiceId: this.projects.order_id,
          projectStatus: this.projects.status,
          projects: projects,
          projectKey: projectKey,
          sectionKey: sectionKey,
          customItemKey: customItemKey,
        },
        userId: projects.user_id,
        orderType: this.orderType,
        assignStatus: this.projects.status,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.getOrderList();
      }
    });
  }

  getTaxDisplay(taxExempt: boolean, tax: string | number): string {
    const taxValue = parseFloat(tax as string);
    if (taxExempt && taxValue === 0) {
      return 'Tax Exempt';
    } else {
      return `$${taxValue.toFixed(2)}`;
    }
  }

  syncInvoice = function (invoice_id: string) {
    this.options = {
      id: localStorage.getItem("userID"),
      invoice_id: invoice_id
    };
    this.CommonService.apiService(
      "POST",
      "qbo/syncInvoice",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {

          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 5000
          });

        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  };

  printStoreBoxLabel = function () {
    this.loading = true;
    let printOptions = {
      id: this.shopId,
      store_id: this.storeId
    }

    this.CommonService.apiService(
      "POST",
      "store/printLabels",
      printOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          const storeLabelData = {
            labels: response.data.labels,
            store: response.data.store,
            user: response.data.user
          };
          localStorage.setItem('storeLabelData', JSON.stringify(storeLabelData));
      
          const url = '/stores/shipping-labels/' + this.storeId;
          window.open(url, '_blank');
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  printStoreCustomerOrders () {
    const url = '/stores/customer-orders/' + this.storeId;
    window.open(url, '_blank');
  }

  getPaymentHistory(orderType, orderId) {
    if (orderType === 'Invoice') {
      this.CommonService.getPaymentHistory({order_id: orderId}).subscribe((response: any) => {
        if (response.status === true) {
          this.paymentHistory = response.data;
        }
      },
        err => {
          this.paymentHistory = [];
        }
      );

      this.getRefundHistory(orderId);

    }
  }

  getRefundHistory(orderId) {
    this.CommonService.getRefundHistory({order_id: orderId}).subscribe((response: any) => {
      if (response.status === true) {
        this.refundHistory = response.data;
      }
    },
      err => {
        this.refundHistory = [];
      }
    );
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/invoices-form/invoices-form.component.ts